<template>
  <div :class="{ 'floor-plan--standard': !isTheaterOrganization }">
    <div
      :style="!floorPlanAvailable || effectiveSoldOut ? 'display: flex; justify-content: center' : ''"
    >
      <div v-if="onlineSale && floorPlanAvailable && !effectiveSoldOut" style="margin-bottom: 2.5rem">
        <module-title v-if="!isZkm" color="#333333" :title="workflowLabel(getTitle)" :font-style="titleStyle" />
        <module-title v-else :color="secondaryColor" :title="workflowLabel(workflowCustomerLabel('buyATicketZkm', {}, $t('buyATicketZkm')))" :event="event" />
      </div>
      <div v-if="!floorPlanAvailable || effectiveSoldOut" class="no-tickets">
        <div
          v-if="isTheaterOrganization"
          class="d-flex justify-center"
          style="cursor: pointer"
          @click="goToEventDetailsPage"
        >
          <img src="/assets/keyboard-arrow-back.svg" :alt="adminText('workflowsAll.back_button_4e9e2cc', 'Back Button')" />
          <div class="text-uppercase font-weight-bold pl-2">{{ workflowLabel(workflowCustomerLabel('backToEvent', {}, $t('backToEvent'))) }}</div>
        </div>

        <img :src="getModalImage" :alt="adminText('workflowsAll.no_tickets_d399337', 'no tickets')" style="align-self: center" />
        <module-title
          color="#333333"
          :title="workflowLabel(getModalTitle)"
          :description="workflowLabel(getModalDescription)"
          :show-events-button="true"
          :show-ticket-swap-button="effectiveSoldOut && !event.canceled"
          :event="event"
          class="pb-4"
          style="align-self: center"
        />
      </div>
      <div v-if="isZkm" style="height: 100px" />
      <div v-if="showParterTickets && !showParterTicketsBelowFloorPlan">
        <ticket-card
          v-for="orderItem in parterAsTicket"
          :key="orderItem.id"
          :ticket="orderItem"
          :event="event"
          :promo-code="promoCode"
          :can-add-more="canAddMoreTickets && canAddParterTicket(orderItem)"
          :items="workflowUi(selectedTicket)"
          color="#333333"
          style="margin-bottom: 1rem"
          background-color="#3333330d"
          active-background-color="white"
          @added="addParterAsTicketToCart(orderItem)"
          @removed="removeParterAsTicketToCart(orderItem)"
        />
      </div>
      <div
        v-if="floorPlanAvailable && !effectiveSoldOut"
        class="floor-plan-wrapper"
        :style="!onlineSale && 'margin-top: 1rem'"
      >
        <div v-if="isTheaterOrganization" class="choose-ticket-category-wrapper">
          <h2 class="choose-ticket-category-title">1. {{ workflowLabel(workflowCustomerLabel('chooseTicketCategory', {}, $t('chooseTicketCategory'))) }}</h2>
          <v-select
            v-if="!loading"
            v-model="currTicket"
            :items="workflowUi(getOrderItems)"
            item-value="id"
            class="ticket-dropdown-container"
            :menu-props="{ contentClass: 'ticket-dropdown-menu' }"
            hide-details
            box
            @change="handleTicketClick"
          >
            <template v-slot:item="{ item }">
              <ticket-dropdown-item :ticket="item" :selected="currTicket === item.id" />
            </template>
            <template v-slot:selection="{ item }">
              <ticket-dropdown-item
                v-if="item"
                :ticket="item"
                :selected="true"
                :truncate-title="true"
              />
            </template>
          </v-select>
          <div v-if="showRemainingTicketsChip" class="remaining-tickets-chip">
            <span>{{ workflowLabel(workflowCustomerLabel('remainingSeats', {}, $t('remainingSeats'))) }}</span>
            <span class="remaining-tickets-chip__count">
              <img src="/assets/tickets-chip.svg" alt="">
              {{ workflowLabel(numOfRemainingTickets) }}
            </span>
          </div>
          <div v-if="currentTicketIsAccessible" class="accessible-info-banner">
            <v-icon size="24" color="#0277BD">info_outline</v-icon>
            <span>{{ workflowLabel(workflowCustomerLabel('accessibleTicketInfo', {}, $t('accessibleTicketInfo'))) }}</span>
          </div>
        </div>
        <floor-plan-ticket-filter
          v-else-if="!loading"
          :value="floorPlanTicketFilter"
          :tickets="workflowUi(getOrderItems)"
          :label="workflowCustomerLabel('chooseFloorPlanTicket')"
          :all-label="workflowCustomerLabel('allFloorPlanTicketTypes')"
          @input="handleFloorPlanTicketFilter"
        />
        <h2 class="select-location-title">
          {{ workflowLabel(isTheaterOrganization ? '2. ' : '') }}{{ workflowLabel(workflowCustomerLabel('selectLocation', {}, $t('selectLocation'))) }}
        </h2>
        <div v-if="bundleOfferFloorPlanPrompt.show" class="bundle-offer-info-banner">
          <v-icon size="20" color="#0058A3" style="margin-right: 8px">info_outline</v-icon>
          <span>
            {{ workflowLabel(workflowCustomerLabel('bundleOfferChooseMore', {}, $t('bundleOfferChooseMore'))) }}
            <strong>{{
              workflowLabel(workflowCustomerLabel('bundleOfferChooseMoreGratisCount', { count: bundleOfferFloorPlanPrompt.count }, $t('bundleOfferChooseMoreGratisCount', { count: bundleOfferFloorPlanPrompt.count })))
            }}</strong
            >.
          </span>
        </div>
        <div id="spinner-svg-wrapper">
          <div v-if="loadingSvg" id="spinner-container">
            <spinner />
          </div>
          <div v-if="!loading" style="position: relative">
            <floor-plan-element-dialog
              v-if="dialogElement"
              :open-dialog="openFloorPlanElementDialog"
              :order-item="dialogElement"
              :quantity-limit="seatLimitPerOrder"
              :available-table-quantity="
                isSharedTable(dialogElement)
                  ? Number((venueAvailability[dialogElementId] || {}).availableCount || 0)
                  : null
              "
              :item-quantity-limit="getDialogElementQuantityLimit(dialogElement)"
              :current-selected-amount="getNumOfSelectedElements()"
              :initial-quantity="initialFloorPlanDialogElementQuantity"
              :is-initially-selected="
                !!dialogElementId &&
                (!!elementDetails[dialogElementId] || selectedSeats.includes(dialogElementId))
              "
              @closeDialog="closeDialogElement"
              @removeTicketFromOrder="removeDialogElementFromOrder"
              @addTickets="addDialogElementFromOrder($event)"
            />
            <object
              id="svgfile"
              :data="workflowUi(venue.imageUrl)"
              type="image/svg+xml"
              :style="floorPlanSvgStyle"
            />
            <seat-info
              :seat="hoveredSeat"
              :show-info="seatInfoVisible && !seatCardVisible"
              :position="seatInfoPosition"
              :ticket="currTicket"
              :order-items="orderItems"
            />
            <seat-detail-card
              :visible="seatCardVisible"
              :state="seatCardState"
              :seat-id="seatCardSeatId"
              :ticket-name="seatCardTicketName"
              :price="seatCardPrice"
              :currency="seatCardCurrency"
              :description="workflowLabel(seatCardDescription)"
              :type="seatCardType"
              :table-capacity="seatCardTableCapacity"
              :anchor-x="seatCardAnchorX"
              :anchor-y="seatCardAnchorY"
              :show-escort-question="seatCardShowEscortQuestion"
              @add="handleSeatCardAdd"
              @cancel="handleSeatCardCancel"
            />
            <div v-show="!loadingSvg" id="svg-action-buttons-wrapper">
              <v-icon
                v-if="isTheaterOrganization"
                id="zoomIn"
                class="material-icons"
                :size="43"
                :color="isZkm ? '#333' : zoomInIconColor"
              >
                add_circle
              </v-icon>
              <button
                v-else
                id="zoomIn"
                type="button"
                class="floor-plan-zoom-control"
                :disabled="zoomInIconColor === '#D9D9D9'"
                :aria-label="workflowCustomerLabel('floorPlanZoomIn')"
              >
                <img src="/assets/floor-plan-controls/zoom-in.svg" class="floor-plan-zoom-control__mobile" alt="">
                <v-icon class="floor-plan-zoom-control__desktop" size="43" :color="zoomInIconColor">add_circle</v-icon>
              </button>
              <v-icon
                v-if="isTheaterOrganization"
                id="zoomOut"
                class="material-icons"
                :size="43"
                :color="isZkm ? '#333' : zoomInIconColor"
              >
                remove_circle
              </v-icon>
              <button
                v-else
                id="zoomOut"
                type="button"
                class="floor-plan-zoom-control"
                :disabled="zoomOutIconColor === '#D9D9D9'"
                :aria-label="workflowCustomerLabel('floorPlanZoomOut')"
              >
                <img src="/assets/floor-plan-controls/zoom-out.svg" class="floor-plan-zoom-control__mobile" alt="">
                <v-icon class="floor-plan-zoom-control__desktop" size="43" :color="zoomOutIconColor">remove_circle</v-icon>
              </button>
              <v-icon
                v-if="isTheaterOrganization"
                id="resetZoom"
                class="material-icons"
                :size="43"
                :color="isZkm ? '#333' : zoomInIconColor"
              >
                replay_circle_filled
              </v-icon>
              <button
                v-else
                id="resetZoom"
                type="button"
                class="floor-plan-zoom-control"
                :aria-label="workflowCustomerLabel('floorPlanResetView')"
              >
                <img src="/assets/floor-plan-controls/reset.svg" class="floor-plan-zoom-control__mobile" alt="">
                <v-icon class="floor-plan-zoom-control__desktop" size="43" :color="resetZoomIconColor">replay_circle_filled</v-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="seat-state-wrapper" :class="{ 'seat-state-wrapper--chips': !isTheaterOrganization }">
          <div class="seat-state-description">
            <img v-if="!isTheaterOrganization" src="/assets/floor-plan-legend/unavailable.svg" alt="">
            <div
              v-else
              class="unavailable-seat"
              style="background: #f5f5f5"
            />
            <span>{{ workflowLabel(workflowCustomerLabel('unavailableSeat', {}, $t('unavailableSeat'))) }}</span>
          </div>
          <div class="seat-state-description">
            <img v-if="!isTheaterOrganization" src="/assets/floor-plan-legend/selected.svg" alt="">
            <div v-else class="selected-seat" :style="{ background: getTicketColor }" />
            <span>{{ workflowLabel(workflowCustomerLabel('selectedSeat', {}, $t('selectedSeat'))) }}</span>
          </div>
          <div v-if="!isTheaterOrganization || theaterHasSectors" class="seat-state-description">
            <img v-if="!isTheaterOrganization" src="/assets/floor-plan-legend/unselected-sector.svg" alt="">
            <div v-else class="unselected-sector-seat" />
            <span>{{ workflowLabel(workflowCustomerLabel('unselectedSector', {}, $t('unselectedSector'))) }}</span>
          </div>
        </div>
        <div v-if="event.id == 5754 || event.id === '5754'" class="package-info">
          <h3>BEAT VIP Tour Package includes:</h3>
          <ul>
            <li>One premium reserved ticket</li>
            <li>Limited edition BEAT tour poster; autographed</li>
            <li>Exclusive BEAT tour merch item</li>
            <li>Commemorative tour laminate & lanyard</li>
            <li>Limited availability</li>
          </ul>
          <h3 style="margin-top: 1rem">BEAT Meet & Greet Package includes:</h3>
          <ul>
            <li>One premium reserved ticket located in the first 5 rows</li>
            <li>Early entry into the venue</li>
            <li>
              Exclusive preshow meet & greet with Adrian Belew, Steve Vai, Tony Levin & Danny Carey
            </li>
            <li>Personal photograph with Adrian Belew, Steve Vai, Tony Levin & Danny Carey</li>
            <li>Limited edition BEAT tour poster; autographed</li>
            <li>Exclusive BEAT tour merch item</li>
            <li>Official meet & greet laminate & lanyard</li>
            <li>Limited availability</li>
          </ul>
        </div>
      </div>
      <div
        v-if="showParterTickets && showParterTicketsBelowFloorPlan"
        class="parter-tickets-below-floor-plan"
      >
        <ticket-card
          v-for="orderItem in parterAsTicket"
          :key="orderItem.id"
          :ticket="orderItem"
          :event="event"
          :promo-code="promoCode"
          :can-add-more="canAddMoreTickets && canAddParterTicket(orderItem)"
          :items="workflowUi(selectedTicket)"
          color="#333333"
          style="margin-bottom: 1rem"
          background-color="#3333330d"
          active-background-color="white"
          @added="addParterAsTicketToCart(orderItem)"
          @removed="removeParterAsTicketToCart(orderItem)"
        />
      </div>
      <simple-snackbar
        :open.sync="snackbarOpen"
        :message-prop="workflowLabel(snackbarMessage)"
        :color="snackbarColor"
      />
    </div>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import ModuleTitle from './../../shared/module-title.vue'
import Spinner from '../../shared/spinner'
import {
  GET_EVENT_FLOOR_PLAN_AND_ORDER_ITEMS,
  GET_EVENT_PARTER_AS_TICKET_ORDER_ITEMS,
} from '@/graphql/event.graphql'
import SimpleSnackbar from '../../shared/snackbars/simple-snackbar.vue'
import moment from 'moment'
import { cloneDeep } from 'lodash'
import * as svgPanZoom from 'svg-pan-zoom'
import * as Hammer from 'hammerjs'
import SeatInfo from '../seat-info.vue'
import SeatDetailCard from '../seat-detail-card.vue'
import {
  MembershipTicketsPerEventLimitByOrganizationId,
  OrganizationType,
  SeatState,
  SvgElementCEType,
  TicketType,
  Venue,
} from '@/types'
import FloorPlanElementDialog from '@/components/accreditations/register-stepper/floor-plan-element-dialog.vue'
import TicketCard from '@/components/tickets/ticket-card.vue'
import { getOrder } from '@/http'
import { countSellableSeats } from '@/utils/floor-plan-quantity'
import TicketDropdownItem from './ticket-dropdown-item.vue'
import FloorPlanTicketFilter from './floor-plan-ticket-filter.vue'

const TABLE_ROW_LOCATION_ORDER_ITEM_IDS = [26836, 24683]
const SPECIAL_TABLE_LOCATION_EVENT_IDS = [7345, 9022]

export default {
  mixins: [WorkflowDisplay],
  components: {
    TicketCard,
    FloorPlanElementDialog,
    ModuleTitle,
    Spinner,
    SimpleSnackbar,
    SeatInfo,
    SeatDetailCard,
    TicketDropdownItem,
    FloorPlanTicketFilter,
  },
  props: {
    managedRegister: { type: Boolean, default: false },
    preserveHeldSelection: { type: Boolean, default: false },
    saleTime: { type: String, default: null },
    inventoryEnabled: { type: Boolean, default: true },
    onlineSale: {
      type: Boolean,
      default: true,
    },
    initialPromoCode: {
      type: String,
      default: null,
    },
    initialSeatSelect: {
      type: Object,
      default: null,
    },
    ticketLocations: {
      type: Object,
      default: () => {},
    },
    updatedOrderItems: {
      type: Object,
      default: () => {},
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    event: {
      type: Object,
      default: null,
    },
    initialValues: {
      type: Array,
      default: () => [],
    },
    promoCode: {
      type: Object,
      default: null,
    },
    membership: {
      type: Object,
      default: null,
    },
    orderItemAccessCode: {
      type: String,
      default: null,
    },
    numOfRemainingTickets: {
      type: Number,
      default: 0,
    },
    showRemainingTicketsChip: {
      type: Boolean,
      default: false,
    },
    sellableOrderItemIds: {
      type: Array,
    },
  },
  data() {
    return {
      registerFloorSoldOut: false,
      seatInfoPosition: { left: '0', top: '0' },
      seatInfoVisible: false,
      hoveredSeat: null,
      venue: null,
      snackbarOpen: false,
      snackbarMessage: '',
      snackbarColor: null,
      canAddMoreTickets: true,
      seatLimitPerOrder: [1783, 1784, 1785].includes(parseInt(this.event.id)) ? 500 : 10,
      initialFloorPlanDialogElementQuantity: 1,
      floorPlanAvailable: true,
      openFloorPlanElementDialog: false,
      zoomInIconColor: '#0277BD',
      zoomOutIconColor: '#0277BD',
      resetZoomIconColor: '#0277BD',
      SvgElementCEType,
      seatState: {
        HOLD: 'hold',
        SOLD: 'sold',
        AVAILABLE: 'available',
      },
      eventListenerType: {
        true: 'touchstart',
        false: 'click',
      },
      isMobile:
        (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) ||
        /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
      orderItems: null,
      allOrderItems: null,
      loadingSvg: true,
      venueAvailability: null,
      initialParterIds: [],
      maxZoom: 3,
      clientY: null,
      dialogElement: null,
      dialogElementId: null,
      clientX: null,
      currTicket: null,
      floorPlanTicketFilter: null,
      elementDetails: {},
      parterAsTicket: [],
      venueSections: [],
      drag: false,
      selectedTicket: [...cloneDeep(this.initialValues)] || [],
      selectedSeats: [],
      svgElement: null,
      svgDocument: null,
      arenaSectionVisualCache: [],
      arenaSectionZoomState: null,
      seatCardVisible: false,
      seatCardState: 'hover',
      seatCardShowEscortQuestion: false,
      seatCardSeatId: '',
      seatCardTicketName: '',
      seatCardPrice: 0,
      seatCardCurrency: 'EUR',
      seatCardDescription: '',
      seatCardType: 'regular',
      seatCardTableCapacity: '',
      seatCardAnchorX: 0,
      seatCardAnchorY: 0,
      seatCardOrderItem: null,
      disabledSeatFill: '#D9D9D9',
      seatSelectionMeta: {},
      requiredSeats: [],
      selectPromo: false,
      bundleOfferSelectionCounter: 0,
      secondaryColor: '#FF4C00',
      titleStyle: {
        fontFamily: 'Raleway',
        fontSize: '2.25rem',
        fontStyle: 'normal',
        fontWeight: '800',
        lineHeight: '120%',
        letterSpacing: '-0.0675rem',
      },
      loading: true,
    }
  },
  computed: {
    effectiveSoldOut() { return this.event.soldOut || (this.managedRegister && this.registerFloorSoldOut) },
    showParterTickets() {
      return (
        !this.loading &&
        this.floorPlanAvailable &&
        !this.effectiveSoldOut &&
        this.parterAsTicket.length > 0
      )
    },
    showParterTicketsBelowFloorPlan() {
      return Number(this.event && this.event.id) === 9236
    },
    orderItemsById() {
      return (this.orderItems || []).reduce((acc, orderItem) => {
        acc[orderItem.id] = orderItem

        return acc
      }, {})
    },
    selectedSeatSet() {
      return new Set(this.selectedSeats)
    },
    floorPlanMinZoom() {
      return !this.isTheaterOrganization && this.isMobile ? 1 : 0.5
    },
    floorPlanSvgStyle() {
      if (!this.isArenaFanPitVenue()) {
        return { width: '100%' }
      }

      return {
        width: '100%',
        height: 'min(72vh, 720px)',
        objectFit: 'contain',
      }
    },
    selectedTicketCountById() {
      return this.selectedTicket.reduce((acc, ticket) => {
        acc[ticket.id] = (acc[ticket.id] || 0) + 1

        return acc
      }, {})
    },
    selectedElementsCount() {
      const selectedSeatIds = this.selectedSeatSet
      const selectedSeatsCount = this.selectedSeats.reduce(
        (count, seatId) => count + (this.elementDetails[seatId] || 1),
        0,
      )
      const extraElementDetailsCount = Object.entries(this.elementDetails).reduce(
        (count, [elementId, value]) => {
          if (selectedSeatIds.has(elementId)) {
            return count
          }

          return count + value
        },
        0,
      )

      return selectedSeatsCount + extraElementDetailsCount
    },
    activeOrderItemsBySeatId() {
      const seatOrderItemsMap = Object.create(null)
      const topLevelSectionOrderItemIds = Object.create(null)

      const orderItems = this.orderItems || []
      orderItems.forEach(orderItem => {
        if (!this.isWithinSaleTime(orderItem, true)) {
          return
        }

        const sectionSeats = orderItem.sectionSeats || []
        sectionSeats.forEach(seatId => {
          if (!seatId) {
            return
          }

          if (!seatOrderItemsMap[seatId]) {
            seatOrderItemsMap[seatId] = []
          }
          seatOrderItemsMap[seatId].push(orderItem)

          if (typeof seatId === 'string' && seatId.startsWith('Section-') && seatId.includes('_')) {
            const topLevelSectionId = seatId.split('_')[0]
            if (!seatOrderItemsMap[topLevelSectionId]) {
              seatOrderItemsMap[topLevelSectionId] = []
            }
            if (!topLevelSectionOrderItemIds[topLevelSectionId]) {
              topLevelSectionOrderItemIds[topLevelSectionId] = new Set(
                this.isArenaFanPitVenue()
                  ? seatOrderItemsMap[topLevelSectionId].map(item => item.id)
                  : [],
              )
            }
            if (!topLevelSectionOrderItemIds[topLevelSectionId].has(orderItem.id)) {
              topLevelSectionOrderItemIds[topLevelSectionId].add(orderItem.id)
              seatOrderItemsMap[topLevelSectionId].push(orderItem)
            }
          }
        })
      })

      return seatOrderItemsMap
    },
    arenaSectionChildSeatsMap() {
      const sectionChildSeatMap = Object.create(null)

      const venueSeats = (this.venue && this.venue.seats) || []
      venueSeats.forEach(seatId => {
        if (
          typeof seatId !== 'string' ||
          !seatId.startsWith('Section-') ||
          !seatId.includes('_') ||
          !seatId.includes('Row-') ||
          !seatId.includes('Seat-')
        ) {
          return
        }

        const topLevelSectionId = seatId.split('_')[0]
        if (!sectionChildSeatMap[topLevelSectionId]) {
          sectionChildSeatMap[topLevelSectionId] = []
        }
        sectionChildSeatMap[topLevelSectionId].push(seatId)
      })

      return sectionChildSeatMap
    },
    getTitle() {
      const notFreeTickets = (this.orderItems || []).filter(
        ticket =>
          Number(ticket.price) > 0 &&
          this.isWithinSaleTime(ticket, true) &&
          ticket.sectionSeats.length,
      )

      const notFreeParterTickets = this.parterAsTicket.filter(
        ticket => Number(ticket.price) > 0 && this.isWithinSaleTime(ticket, true),
      )
      const allAvailableTicketAreFree =
        notFreeTickets.length === 0 && notFreeParterTickets.length === 0
      if (allAvailableTicketAreFree) {
        return this.workflowCustomerLabel('downloadTickets', {}, this.$t('downloadTickets'))
      }

      return this.workflowCustomerLabel('buyATicket', {}, this.$t('buyATicket'))
    },
    getTicketColor() {
      if (!this.currTicket) return 'white'
      const ticket = this.getOrderItemById(this.currTicket)
      if (!ticket) return 'white'

      return ticket.color
    },
    getModalTitle() {
      if (this.event.canceled) {
        return this.workflowCustomerLabel('eventCanceled', {}, this.$t('eventCanceled'))
      }

      if (this.effectiveSoldOut) {
        return this.workflowCustomerLabel('ticketSoldOut', {}, this.$t('ticketSoldOut'))
      }

      return this.workflowCustomerLabel('ticketUnavailable', {}, this.$t('ticketUnavailable'))
    },
    getModalDescription() {
      if (this.event.canceled) {
        return this.workflowCustomerLabel('eventCanceledDescription', {}, this.$t('eventCanceledDescription'))
      }

      if (this.effectiveSoldOut) {
        return this.workflowCustomerLabel('ticketSoldOutDescription', {}, this.$t('ticketSoldOutDescription'))
      }

      if (this.event && this.event.organization && this.event.organization.id === 502) {
        return ''
      }

      return this.workflowCustomerLabel('ticketUnavailableDescription', {}, this.$t('ticketUnavailableDescription'))
    },
    getModalImage() {
      if (this.event.canceled) {
        return '/assets/sad-ticket.svg'
      }

      if (this.effectiveSoldOut) {
        return '/assets/sad-ticket.svg'
      }

      return '/assets/dont-know-ticket.svg'
    },
    isZkm() {
      if (!this.event || !this.event.organization) {
        return false
      }

      return this.event.organization.id == process.env.VUE_APP_ZKM_ORGANIZATION_ID
    },
    isTheaterOrganization() {
      if (!this.event || !this.event.organization) {
        return false
      }

      return this.event.organization.type === OrganizationType.THEATER
    },
    membershipTicketsPerEventLimit() {
      const organizationId = Number(
        this.event && this.event.organization && this.event.organization.id,
      )
      const limit = MembershipTicketsPerEventLimitByOrganizationId[organizationId]

      return typeof limit === 'number' ? limit : null
    },
    membershipTicketLimit() {
      if (!this.membership || !this.membership.membershipPlan) {
        return 0
      }

      const membershipAmount = Number(this.membership.membershipPlan.amount) || 0

      return typeof this.membershipTicketsPerEventLimit === 'number'
        ? Math.min(membershipAmount, this.membershipTicketsPerEventLimit)
        : membershipAmount
    },
    selectedMembershipTicketCount() {
      return this.selectedTicket.filter(ticket => ticket && ticket.membership).length
    },
    disableSeatHoverDetails() {
      return SPECIAL_TABLE_LOCATION_EVENT_IDS.includes(Number(this.event && this.event.id))
    },
    getOrderItems() {
      return (this.orderItems || []).filter(
        ticket =>
          ticket.sectionSeats.length &&
          (this.onlineSale || (!this.onlineSale && ticket.price > 0)) &&
          !(ticket.itemMeta && ticket.itemMeta.isEscort),
      )
    },
    wheelchairSeats() {
      return (this.venue && this.venue.wheelchairSeats) || {}
    },
    currentTicketIsAccessible() {
      const ticket = this.getOrderItemById(this.currTicket)

      return !!(ticket && ticket.itemMeta && ticket.itemMeta.isAccessible)
    },
    theaterHasSectors() {
      if (!this.isTheaterOrganization || !this.venue || !this.venue.seats) {
        return false
      }

      const regularSeats = this.venue.seats.filter(
        seat => typeof seat === 'string' && seat.includes('Row-') && seat.includes('Seat-'),
      )
      if (!regularSeats.length) {
        return false
      }

      return this.getOrderItems.some(ticket => {
        const hasSeatInSector = regularSeats.some(seat => this.orderItemMatchesSeatId(ticket, seat))
        const hasSeatOutsideSector = regularSeats.some(
          seat => !this.orderItemMatchesSeatId(ticket, seat),
        )

        return hasSeatInSector && hasSeatOutsideSector
      })
    },
    bundleOfferFloorPlanPrompt() {
      if (!this.orderItems || !this.orderItems.length) {
        return { show: false, count: 0, ticketId: null }
      }

      const preferredTicket = this.currTicket && this.getOrderItemById(this.currTicket)
      const ticketCandidates = preferredTicket
        ? [preferredTicket, ...this.orderItems.filter(oi => oi.id !== preferredTicket.id)]
        : this.orderItems

      for (const ticket of ticketCandidates) {
        if (!ticket || !ticket.bundleOffer) {
          continue
        }

        const { pendingFreeCount } = this.getBundleOfferSelectionState(ticket)
        if (pendingFreeCount <= 0) {
          continue
        }

        if (!this.hasSelectableGratisSeats(ticket)) {
          continue
        }

        return { show: true, count: pendingFreeCount, ticketId: ticket.id }
      }

      return { show: false, count: 0, ticketId: null }
    },
    bundleOfferSubmitBlockState() {
      if (!this.orderItems || !this.orderItems.length) {
        return { blocked: false, message: '' }
      }

      for (const ticket of this.orderItems) {
        if (!ticket || !ticket.bundleOffer) {
          continue
        }

        const { pendingFreeCount, excessFreeCount } = this.getBundleOfferSelectionState(ticket)

        if (excessFreeCount > 0) {
          return {
            blocked: true,
            message: { workflowCustomer: 'bundleOfferFixExcessGratis', params: { count: excessFreeCount } },
          }
        }

        if (pendingFreeCount > 0 && this.hasSelectableGratisSeats(ticket)) {
          return {
            blocked: true,
            message: { workflowCustomer: 'bundleOfferChooseMoreGratis', params: { count: pendingFreeCount } },
          }
        }
      }

      return { blocked: false, message: '' }
    },
  },
  watch: {
    updatedOrderItems: function () {
      const svgDoc = this.getSvgDocument()

      for (const [orderItemId, value] of Object.entries(this.updatedOrderItems)) {
        if (!orderItemId) {
          continue
        }

        const orderItem =
          this.getOrderItemById(orderItemId) ||
          this.parterAsTicket.find(ticket => String(ticket.id) === String(orderItemId))
        if (!orderItem) {
          continue
        }

        const currentQuantity = this.selectedTicketCountById[orderItemId] || 0
        const newQuantity = value.quantity
        const quantityDifference = currentQuantity - newQuantity

        if (quantityDifference > 0) {
          for (let i = 0; i < quantityDifference; i++) {
            const index = this.selectedTicket.findIndex(t => t.id === orderItemId)
            if (index !== -1) {
              this.selectedTicket.splice(index, 1)
            }
          }
        }

        orderItem.quantity = newQuantity

        const isParterAsTicket = this.parterAsTicket.some(t => t.id === orderItemId)

        if (isParterAsTicket) {
          if (this.elementDetails[orderItemId]) {
            this.$set(this.elementDetails, orderItemId, newQuantity)
          }
          this.$emit('addDialogElementToOrder', [orderItem, newQuantity, TicketType.REGULAR])
        } else {
          const elementIds = orderItem.sectionSeats
          elementIds.forEach(elementId => {
            if (elementId && this.elementDetails[elementId]) {
              this.$set(this.elementDetails, elementId, newQuantity)
            }

            if (newQuantity <= 0) {
              if (svgDoc && svgDoc.getElementById(elementId)) {
                this.applyDisabledElementVisual(svgDoc.getElementById(elementId))
              }
            }
            this.$emit('addDialogElementToOrder', [
              orderItem,
              newQuantity,
              TicketType.REGULAR,
              elementId,
            ])
          })
        }
      }
    },
    orderItemAccessCode() {
      if (!this.managedRegister) this.fetchParterAsTicketOrderItems()
    },
    requiredSeats: {
      handler() {
        this.$emit('requiredSeats', this.requiredSeats)
      },
    },
  },
  mounted() {
    !this.event.venueId && (this.floorPlanAvailable = false)
    this.membership && this.addPromo()
    if (this.initialSeatSelect) {
      let seatIds = []

      this.initialSeatSelect.purchases.map(p => {
        if (p.orderItem.itemMeta.parter) {
          this.initialParterIds.push(p.accreditation.ticketLocation)
        } else {
          seatIds.push(p.accreditation.ticketLocation)
        }
      })
      this.selectedSeats = [...new Set(seatIds)]
    }
    this.rebuildSeatSelectionMetaFromInitialState()
  },
  apollo: {
    getEventFloorPlanAndOrderItems: {
      query: GET_EVENT_FLOOR_PLAN_AND_ORDER_ITEMS,
      variables() {
        return {
          eventId: this.event.id,
          includeOrderItemsWithTicketSellerTrue: !this.onlineSale,
        }
      },
      manual: true,
      skip() { return this.managedRegister },
      async result(result) { return this.applyFloorPlanData(result) },
    },
  },
  methods: {
    isWithinSaleTime(ticket, inclusive = false) {
      const now = this.managedRegister && this.saleTime ? moment(this.saleTime) : moment()

      return now.isBetween(ticket.from, ticket.to, undefined, inclusive ? '[]' : '()')
    },
    async refreshRegisterInventory() {
      if (!this.managedRegister || !this.inventoryEnabled) return
      const request = this._registerInventoryRequest = (this._registerInventoryRequest || 0) + 1
      const eventId = this.event.id
      const accessCode = this.orderItemAccessCode
      const saleTime = this.saleTime
      const variables = { eventId, includeOrderItemsWithTicketSellerTrue: !this.onlineSale, accessCode }
      const [floor, parter] = await Promise.all([
        this.$apollo.query({ query: GET_EVENT_FLOOR_PLAN_AND_ORDER_ITEMS, fetchPolicy: 'no-cache', errorPolicy: 'none', variables }),
        this.$apollo.query({ query: GET_EVENT_PARTER_AS_TICKET_ORDER_ITEMS, fetchPolicy: 'no-cache', errorPolicy: 'none', variables }),
      ])
      if (this._isDestroyed || request !== this._registerInventoryRequest || eventId !== this.event.id ||
        accessCode !== this.orderItemAccessCode || saleTime !== this.saleTime || !this.inventoryEnabled) return
      if (floor.errors || !floor.data || !floor.data.getEventFloorPlanAndOrderItems ||
        !floor.data.getEventFloorPlanAndOrderItems.venue || !Array.isArray(floor.data.getEventFloorPlanAndOrderItems.orderItems) ||
        parter.errors || !parter.data || !Array.isArray(parter.data.getEventParterAsTicketOrderItems)) throw new Error('Floor plan data unavailable')
      await this.applyFloorPlanData(floor, parter.data.getEventParterAsTicketOrderItems)
    },
    async applyFloorPlanData({ data, errors }, freshParter) {
      if (errors || !data) {
        return (this.floorPlanAvailable = false)
      }
      const floorPlanOrderItems = data.getEventFloorPlanAndOrderItems.orderItems.filter(
        orderItem => !this.isParterAsTicketOrderItem(orderItem) &&
          (!this.managedRegister || !orderItem.itemMeta || !orderItem.itemMeta.accessCode || orderItem.itemMeta.accessCode === this.orderItemAccessCode),
      )

      this.venue = data.getEventFloorPlanAndOrderItems.venue
      this.allOrderItems = floorPlanOrderItems.filter(oi => this.isWithinSaleTime(oi))
      this.orderItems = this.mapOrderItems(floorPlanOrderItems)
      if (this.event.organization.type === OrganizationType.THEATER) {
        this.orderItems = this.orderItems.sort((a, b) => b.price - a.price)
      }

      if (this.sellableOrderItemIds) {
        this.orderItems = this.orderItems.filter(oi => this.sellableOrderItemIds.includes(oi.id))
      }
      this.venueAvailability =
        (data.getEventFloorPlanAndOrderItems.venueAvailability &&
          data.getEventFloorPlanAndOrderItems.venueAvailability.availability) ||
        {}
      if (this.managedRegister) {
        this.parterAsTicket = this.getParterAsTicketOrderItems(freshParter)
        this.reconcileRegisterSelection()
        this.loading = false
      } else await this.fetchParterAsTicketOrderItems()

      const svgParterTickets = floorPlanOrderItems.filter(
        oi => this.isWithinSaleTime(oi) && oi.itemMeta.parter,
      )
      const parterTickets = [...svgParterTickets, ...this.parterAsTicket]
      if (!this.orderItems.length && !this.parterAsTicket.length) {
        return (this.floorPlanAvailable = false)
      }

      const soldSvgElements = Object.values(this.venueAvailability || {}).filter(
        seat => seat && seat.state === SeatState.SOLD,
      )
      const isEverySeatSold = soldSvgElements.length === countSellableSeats(this.venue.seats)

      const hasNoAvailableParterTickets = !parterTickets.some(oi => Number(oi.quantity) > 0)

      if (this.managedRegister) this.registerFloorSoldOut = isEverySeatSold && hasNoAvailableParterTickets
      else if (isEverySeatSold && hasNoAvailableParterTickets) return (this.event.soldOut = true)
      this.floorPlanAvailable = !!(this.orderItems.length || this.parterAsTicket.length)
      this.membership && this.addMembershipOrderItem(this.membership)
      this.setOrderLimitation(this.orderItems)

      this.loading = false

      if (this.managedRegister) {
        await this.$nextTick()
        this.refreshRegisterSvg()

        return
      }
      // problem with rendering SVG file
      setTimeout(() => {
        const svgObject = this.getSvgObject()
        if (!svgObject) {
          return
        }

        svgObject.addEventListener(
          'load',
          () => {
            const svgDoc = this.getSvgDocument()
            if (!svgDoc) {
              return
            }

            this.hammerInit()
            if (this.orderItems.length) this.handleTicketClick(this.defaultStartTicketId())
            this.initialSvgColors(svgDoc)
            this.initialTableAndParterDataAndColoring(svgDoc)
            this.loadingSvg = false
            document.getElementById('spinner-svg-wrapper').style.height = 'fit-content'
          },
          { once: true },
        )
      }, 0)
    },
    reconcileRegisterSelection() {
      if (!this.managedRegister || this.preserveHeldSelection) return
      const freshById = new Map([...this.allOrderItems, ...this.parterAsTicket].map(ticket => [String(ticket.id), ticket]))
      const selectedById = new Map()
      this.selectedTicket.forEach(ticket => {
        const key = String(ticket.id)
        selectedById.set(key, [...(selectedById.get(key) || []), ticket])
      })
      const removedIds = new Set()
      for (const [id, selected] of selectedById) {
        const fresh = freshById.get(id)
        const free = selected.filter(ticket => ticket.bundleOfferId)
        // Only parter stock is bounded by quantity; seated tickets are checked against seat state below.
        const quantityBound = fresh && fresh.itemMeta && fresh.itemMeta.parter
        if (!fresh || !this.isWithinSaleTime(fresh) ||
          (quantityBound && (Number(fresh.quantity) < selected.length || !Number.isFinite(Number(fresh.quantity)))) ||
          (selected.some(ticket => ticket.itemMeta && ticket.itemMeta.isEscort) &&
            (!fresh.itemMeta || !fresh.itemMeta.isEscort || Number(fresh.price) !== 0)) ||
          (this.sellableOrderItemIds && !this.sellableOrderItemIds.some(value => String(value) === id)) ||
          (fresh.itemMeta && fresh.itemMeta.accessCode && fresh.itemMeta.accessCode !== this.orderItemAccessCode) ||
          (free.length && (!fresh.bundleOffer || free.some(ticket => ticket.bundleOfferId !== fresh.bundleOffer.id) ||
            free.length > this.getBundleFreeCountForNonSeatQuantity(fresh, selected.length)))) {
          removedIds.add(id)
        }
      }
      const doc = this.getSvgDocument()
      const seatTicketIds = new Map()
      for (const seat of this.selectedSeats) {
        const meta = this.seatSelectionMeta[seat]
        const element = doc && doc.getElementById(seat)
        const id = (meta && meta.ticketId) || (element && element.getAttribute('ticketId')) ||
          Object.keys(this.ticketLocations || {}).find(ticketId => this.ticketLocations[ticketId].some(location =>
            location.seats.some(number => `${location.section}_${location.row}_Seat-${number}` === seat)))
        if (id == null) {
          // Ambiguous old location metadata cannot authorize a refreshed selection.
          for (const selectedId of selectedById.keys()) removedIds.add(selectedId)
          continue
        }
        seatTicketIds.set(seat, String(id))
        const fresh = freshById.get(String(id))
        const availability = this.venueAvailability[seat]
        if (!fresh || !this.orderItemMatchesSeatId(fresh, seat) ||
          (!(fresh.itemMeta && fresh.itemMeta.parter) && (!availability || availability.state !== this.seatState.AVAILABLE)) ||
          (availability && availability.availableCount != null && Number(availability.availableCount) < (this.elementDetails[seat] || 1))) {
          removedIds.add(String(id))
        }
      }
      // Remove the affected type as a unit: do not silently reallocate seats,
      // alter shared-table packages, or turn a lost gratis grant into a charge.
      const removedSeats = this.selectedSeats.filter(seat => !seatTicketIds.has(seat) || removedIds.has(seatTicketIds.get(seat)))
      // Escort entitlement follows surviving accessible anchors, including the
      // exact seat pairing recorded when a companion seat was selected.
      const accessibleCounts = {}
      for (const ticket of this.selectedTicket) {
        const fresh = freshById.get(String(ticket.id))
        if (!removedIds.has(String(ticket.id)) && fresh && fresh.itemMeta && fresh.itemMeta.isAccessible) {
          const template = String(fresh.orderItemTemplateId)
          accessibleCounts[template] = (accessibleCounts[template] || 0) + 1
        }
      }
      const escortLimits = new Map()
      for (const [id, selected] of selectedById) {
        if (removedIds.has(id) || !selected[0].itemMeta || !selected[0].itemMeta.isEscort) continue
        const seats = this.selectedSeats.filter(seat => seatTicketIds.get(seat) === id)
        const validSeats = seats.filter(seat => {
          const meta = this.seatSelectionMeta[seat]

          return !removedSeats.includes(seat) && !(meta && meta.escortOf &&
            (!this.selectedSeats.includes(meta.escortOf) || removedSeats.includes(meta.escortOf)))
        })
        const template = String(selected[0].orderItemTemplateId)
        const limit = Math.max(0, Math.min(selected.length - (seats.length - validSeats.length), accessibleCounts[template] || 0))
        accessibleCounts[template] = (accessibleCounts[template] || 0) - limit
        escortLimits.set(id, limit)
        if (limit && Object.prototype.hasOwnProperty.call(this.elementDetails, id)) this.$set(this.elementDetails, id, limit)
        const retainedSeats = validSeats.slice(0, limit)
        for (const seat of seats) if (!retainedSeats.includes(seat) && !removedSeats.includes(seat)) removedSeats.push(seat)
        if (!limit) removedIds.add(id)
      }
      removedSeats.forEach(seat => {
        this.$delete(this.elementDetails, seat)
        this.$delete(this.seatSelectionMeta, seat)
      })
      removedIds.forEach(id => this.$delete(this.elementDetails, id))
      this.selectedSeats = this.selectedSeats.filter(seat => !removedSeats.includes(seat))
      this.requiredSeats = this.requiredSeats.filter(seat => !removedSeats.includes(seat))
      let changedPrices = false
      this.selectedTicket = this.selectedTicket.filter(ticket => {
        const id = String(ticket.id)
        if (removedIds.has(id)) return false
        if (escortLimits.has(id)) {
          const remaining = escortLimits.get(id)
          escortLimits.set(id, Math.max(0, remaining - 1))

          return remaining > 0
        }

        return true
      }).map(ticket => {
        const fresh = freshById.get(String(ticket.id))
        const updated = { ...ticket, ...fresh, ...(ticket.bundleOfferId ? { price: 0, bundleOfferId: ticket.bundleOfferId } : {}) }
        if (Number(updated.price) !== Number(ticket.price)) changedPrices = true

        return updated
      })
      if (this.dialogElement) {
        if (removedIds.has(String(this.dialogElement.id))) {
          this.openFloorPlanElementDialog = false
          this.dialogElement = null
          this.dialogElementId = null
        } else this.dialogElement = freshById.get(String(this.dialogElement.id)) || this.dialogElement
      }
      if (this.seatCardOrderItem) {
        const fresh = freshById.get(String(this.seatCardOrderItem.id))
        const availability = this.venueAvailability[this.seatCardSeatId]
        if (!fresh || removedIds.has(String(fresh.id)) || !this.isWithinSaleTime(fresh) || Number(fresh.quantity) <= 0 ||
          (availability && availability.state !== this.seatState.AVAILABLE)) this.hideSeatCard()
        else {
          this.seatCardOrderItem = fresh
          this.seatCardShowEscortQuestion = this.seatCardState === 'click' && this.shouldShowEscortQuestion(this.seatCardSeatId, fresh)
        }
      }
      if (removedIds.has(String(this.currTicket))) this.currTicket = null
      this.canAddMoreTickets = this.canAddMoreCheck()
      this.$emit('registerSelectionReconciled', {
        eventId: this.event.id, tickets: this.selectedTicket, removedTicketIds: [...removedIds], removedSeats, changedPrices,
      })
    },
    defaultStartTicketId() {
      return (this.orderItems.find(oi => oi.prepaidCoupon && !oi.membership) || this.orderItems[0]).id
    },
    refreshRegisterSvg() {
      const svgObject = this.getSvgObject()
      if (!svgObject) return
      const initialize = () => {
        const doc = this.getSvgDocument()
        if (!doc || !doc.getElementById('svgfile')) return
        if (this._registerInitializedSvg === doc) {
          this.handleSeatColoring(doc)
          this.handleParterColoring(doc)
          this.renderWheelchairSeatIcons(doc)

          return
        }
        this._registerInitializedSvg = doc
        this.hammerInit()
        if (this.orderItems.length && !this.getOrderItemById(this.currTicket)) this.handleTicketClick(this.defaultStartTicketId())
        this.initialSvgColors(doc)
        if (this.initialSeatSelect) this.initialTableAndParterDataAndColoring(doc)
        this.loadingSvg = false
        const spinner = document.getElementById('spinner-svg-wrapper')
        if (spinner) spinner.style.height = 'fit-content'
      }
      if (this._registerSvgObject !== svgObject) {
        this._registerSvgObject = svgObject
        svgObject.addEventListener('load', initialize, { once: true })
      }
      initialize()
    },
    getOrder,
    isParterAsTicketOrderItem(orderItem) {
      return !!(
        orderItem &&
        orderItem.itemMeta &&
        orderItem.itemMeta.parter &&
        !(orderItem.sectionSeats || []).length
      )
    },
    getParterAsTicketOrderItems(orderItems) {
      return (orderItems || [])
        .filter(
          orderItem =>
            this.isParterAsTicketOrderItem(orderItem) &&
            this.isWithinSaleTime(orderItem),
        )
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    },
    async fetchParterAsTicketOrderItems() {
      if (!this.event || !this.event.id) {
        return
      }

      try {
        const { data } = await this.$apollo.query({
          query: GET_EVENT_PARTER_AS_TICKET_ORDER_ITEMS,
          fetchPolicy: 'network-only',
          variables: {
            eventId: this.event.id,
            includeOrderItemsWithTicketSellerTrue: !this.onlineSale,
            accessCode: this.orderItemAccessCode,
          },
        })

        this.setParterAsTicketOrderItems((data && data.getEventParterAsTicketOrderItems) || [])
      } catch (error) {
        console.error('Failed to fetch parter tickets:', error)
        this.setParterAsTicketOrderItems([])
      }
    },
    setParterAsTicketOrderItems(orderItems) {
      const nextParterTickets = this.getParterAsTicketOrderItems(orderItems)

      this.removeUnavailableSelectedParterTickets(nextParterTickets)
      this.parterAsTicket = nextParterTickets
      this.floorPlanAvailable = !!((this.orderItems || []).length || nextParterTickets.length)
      this.loading = false
      if (nextParterTickets.some(ticket => Number(ticket.quantity) > 0)) {
        if (this.managedRegister) this.registerFloorSoldOut = false
        else this.event.soldOut = false
      }
      this.canAddMoreTickets = this.canAddMoreCheck()
    },
    removeUnavailableSelectedParterTickets(nextParterTickets) {
      const nextTicketIds = new Set(nextParterTickets.map(ticket => String(ticket.id)))
      const removedTickets = this.parterAsTicket.filter(
        ticket => !nextTicketIds.has(String(ticket.id)),
      )

      removedTickets.forEach(ticket => {
        const selectedQuantity =
          this.elementDetails[ticket.id] ||
          this.selectedTicket.filter(item => String(item.id) === String(ticket.id)).length

        if (!selectedQuantity) {
          return
        }

        this.$delete(this.elementDetails, ticket.id)
        this.selectedTicket = this.selectedTicket.filter(
          item => String(item.id) !== String(ticket.id),
        )
        this.$emit('addDialogElementToOrder', [
          ticket,
          0,
          TicketType.REGULAR,
          null,
          { totalQuantityForTicketId: 0 },
        ])
      })
    },
    getSvgObject() {
      if (this.managedRegister) {
        const current = this.$el && this.$el.querySelector('object#svgfile')
        if (this.svgElement !== current) {
          this.svgElement = current
          this.svgDocument = null
        }

        return current
      }
      if (!this.svgElement) {
        this.svgElement = document.getElementById('svgfile')
      }

      return this.svgElement
    },
    getSvgDocument() {
      const svgObject = this.getSvgObject()
      const svgDocument = svgObject && svgObject.getSVGDocument()

      if (svgDocument) {
        this.svgDocument = svgDocument
      }

      return svgDocument || this.svgDocument
    },
    getOrderItemById(orderItemId) {
      return this.orderItemsById[orderItemId] || null
    },
    getTicketDisplayName(ticketName) {
      if (!ticketName) {
        return ticketName
      }

      return ticketName.split('-')[0].trim()
    },
    goToEventDetailsPage() {
      const url = `${process.env.VUE_APP_LANDING_URL}/events/${this.event.slug}`
      window.open(url, '_blank')
    },
    initialTableAndParterDataAndColoring(svgDoc) {
      if (this.selectedSeats.length || this.initialParterIds.length) {
        const tableAndParterLocationIds = this.initialSeatSelect.purchases
          .map(p => {
            const locationId = p.accreditation.ticketLocation
            const elementType = this.getSvgElementType(svgDoc, locationId)
            const isTableTicket = elementType === this.SvgElementCEType.TABLE
            const isParterTicket = elementType === this.SvgElementCEType.PARTER
            if (isTableTicket) {
              return locationId
            } else if (isParterTicket) {
              svgDoc.getElementById(locationId).style.fill = p.orderItem.color

              return locationId
            }
          })
          .filter(Boolean)
        tableAndParterLocationIds.map(
          id => (this.elementDetails[id] = (this.elementDetails[id] || 0) + 1),
        )
      }
    },
    mapOrderItems(data) {
      return data.filter(oi => this.isWithinSaleTime(oi) && !oi.membership)
    },
    showSeatInfo(seat, event) {
      this.hoveredSeat = seat
      this.seatInfoVisible = true
      this.seatInfoPosition = {
        left: event.clientX + 8 + 'px',
        top: event.clientY + 'px',
      }
    },
    hideSeatInfo() {
      this.seatInfoVisible = false
    },
    setOrderLimitation() {
      const sharedTableCapacity = this.orderItems.reduce((capacity, orderItem) => {
        if (!this.isSharedTable(orderItem)) {
          return capacity
        }

        const tableCount = new Set(orderItem.sectionSeats || []).size
        const tableCapacity = Number(orderItem.itemMeta.sharedTable.capacity)

        return Number.isInteger(tableCapacity) && tableCapacity > 0
          ? capacity + tableCount * tableCapacity
          : capacity
      }, 0)

      if (
        [
          4242, 4243, 7000, 6999, 6998, 6997, 6996, 6993, 6992, 6991, 6990, 6981, 6967, 7010, 7011,
          7012, 7013, 7018, 7016, 7017, 7025, 7020,
        ].includes(parseInt(this.event.id))
      ) {
        this.seatLimitPerOrder = 6
      } else if ([5740, 5743].includes(parseInt(this.event.id))) {
        this.seatLimitPerOrder = 4
      } else {
        this.seatLimitPerOrder = Math.max(
          10,
          ...this.orderItems.map(oi => oi.itemMeta.max).filter(Boolean),
        )
      }

      // A shared-table package consumes several tickets, but its capacity is
      // local to one SVG table. The legacy order limit used the largest single
      // table capacity and therefore made a second table appear unavailable.
      this.seatLimitPerOrder = Math.max(this.seatLimitPerOrder, sharedTableCapacity)
    },
    getNumOfSelectedElements() {
      return this.selectedElementsCount
    },
    removeDialogElementFromOrder() {
      this.switchElementDialogState()
      this.clearElementDetailsAndLocationInfo()
    },
    closeDialogElement() {
      this.switchElementDialogState()
      this.clearElementDetailsAndLocationInfo()
    },
    addDialogElementFromOrder(ticketQuantity) {
      const orderItem = this.getFilteredOrderItemsForSeatId(this.dialogElementId)[0]
      if (!orderItem) return
      const svgDoc = this.getSvgDocument()
      const elementType = this.getSvgElementType(svgDoc, this.dialogElementId)
      const previousQuantity = this.elementDetails[this.dialogElementId] || 0
      const direction = ticketQuantity >= previousQuantity ? 'up' : 'down'
      const maxAllowedQuantity = this.getMaxAllowedNonSeatQuantity(orderItem, previousQuantity)
      const requestedTicketQuantity = Math.min(ticketQuantity, maxAllowedQuantity)
      const adjustedTicketQuantity = this.isSharedTable(orderItem)
        ? requestedTicketQuantity
        : this.getBundleAdjustedNonSeatQuantity(orderItem, requestedTicketQuantity, direction)
      const finalTicketQuantity =
        adjustedTicketQuantity <= maxAllowedQuantity
          ? adjustedTicketQuantity
          : requestedTicketQuantity
      if (elementType === SvgElementCEType.PARTER) {
        finalTicketQuantity === 0 && delete this.elementDetails[this.dialogElementId]
      } else {
        if (finalTicketQuantity <= 0) {
          this.switchElementDialogState()
          this.clearElementDetailsAndLocationInfo()

          return
        }

        this.addWhiteColorOnElementSelect(this.dialogElementId, svgDoc)
        if (!this.selectedSeats.includes(this.dialogElementId)) {
          this.selectedSeats.push(this.dialogElementId)
        }
        svgDoc.getElementById(this.dialogElementId).setAttribute('ticketId', orderItem.id)
      }
      if (finalTicketQuantity > 0) {
        this.$set(this.elementDetails, this.dialogElementId, finalTicketQuantity)
      }
      const totalQuantityForTicketId = this.getNonSeatSelectedQuantityForTicket(orderItem)
      this.replaceSelectedTicketsForOrderItem(
        orderItem,
        this.buildSelectedTicketsForNonSeatQuantity(orderItem, totalQuantityForTicketId),
        { notifyGratisAdded: false },
      )
      this.$emit('addDialogElementToOrder', [
        this.dialogElement,
        finalTicketQuantity,
        elementType,
        this.dialogElementId,
        { totalQuantityForTicketId },
      ])
      this.canAddMoreTickets = this.canAddMoreCheck()
      if (finalTicketQuantity > 0) {
        this.initialFloorPlanDialogElementQuantity = finalTicketQuantity
      } else {
        this.switchElementDialogState()
        this.clearElementDetailsAndLocationInfo()
      }
    },
    clearElementDetailsAndLocationInfo() {
      this.dialogElementId = null
      this.dialogElement = null
      this.initialFloorPlanDialogElementQuantity = 1
    },
    getBundleAdjustedNonSeatQuantity(ticket, quantity, direction = 'up') {
      const bundleOffer = ticket && ticket.bundleOffer
      if (!bundleOffer || bundleOffer.availableQuantity <= 0 || quantity <= 0) {
        return quantity
      }

      const quantityInterval = Number(bundleOffer.quantityInterval)
      const freeQuantity = Number(bundleOffer.freeQuantity)
      const availableQuantity = Number(bundleOffer.availableQuantity)
      const bundleSize = quantityInterval + freeQuantity

      if (!quantityInterval || !freeQuantity || !bundleSize || !availableQuantity) {
        return quantity
      }

      const maxBundleCoveredQuantity = bundleSize * availableQuantity
      if (quantity > maxBundleCoveredQuantity) {
        return quantity
      }

      const remainder = quantity % bundleSize
      if (remainder < quantityInterval || remainder === 0) {
        return quantity
      }

      if (direction === 'down') {
        return quantity - (remainder - (quantityInterval - 1))
      }

      return quantity + (bundleSize - remainder)
    },
    getBundleFreeCountForNonSeatQuantity(ticket, quantity) {
      const bundleOffer = ticket && ticket.bundleOffer
      if (!bundleOffer || bundleOffer.availableQuantity <= 0 || quantity <= 0) {
        return 0
      }

      const quantityInterval = Number(bundleOffer.quantityInterval)
      const freeQuantity = Number(bundleOffer.freeQuantity)
      const availableQuantity = Number(bundleOffer.availableQuantity)
      const bundleSize = quantityInterval + freeQuantity

      if (!quantityInterval || !freeQuantity || !bundleSize || !availableQuantity) {
        return 0
      }

      const bundleCoveredQuantity = Math.min(quantity, bundleSize * availableQuantity)
      const fullBundles = Math.floor(bundleCoveredQuantity / bundleSize)
      const remainder = bundleCoveredQuantity % bundleSize

      return fullBundles * freeQuantity + Math.max(remainder - quantityInterval, 0)
    },
    buildSelectedTicketsForNonSeatQuantity(ticket, quantity) {
      if (!ticket || quantity <= 0) {
        return []
      }

      const freeCount = this.getBundleFreeCountForNonSeatQuantity(ticket, quantity)
      const paidCount = Math.max(quantity - freeCount, 0)
      const paidTickets = Array.from({ length: paidCount }, () => ticket)
      const freeTickets =
        ticket.bundleOffer && freeCount > 0
          ? Array.from({ length: freeCount }, () => ({
            ...ticket,
            price: 0,
            bundleOfferId: ticket.bundleOffer.id,
          }))
          : []

      return [...paidTickets, ...freeTickets]
    },
    showBundleGratisAddedSnackbar(count) {
      if (!count || count <= 0) {
        return
      }

      this.snackbarColor = 'primary'
      this.snackbarMessage = { workflowCustomer: 'bundleOfferGratisAdded', params: { count } }
      this.snackbarOpen = true
    },
    replaceSelectedTicketsForOrderItem(ticket, tickets, options = {}) {
      if (!ticket) {
        return
      }

      const previousFreeCount = ticket.bundleOffer
        ? this.selectedTicket.filter(
          item => item.id === ticket.id && item.bundleOfferId === ticket.bundleOffer.id,
        ).length
        : 0
      const nextFreeCount = ticket.bundleOffer
        ? tickets.filter(item => item.bundleOfferId === ticket.bundleOffer.id).length
        : 0

      this.selectedTicket = [
        ...this.selectedTicket.filter(item => item.id !== ticket.id),
        ...tickets,
      ]

      if (options.notifyGratisAdded !== false) {
        this.showBundleGratisAddedSnackbar(nextFreeCount - previousFreeCount)
      }
    },
    getNonSeatSelectedQuantityForTicket(ticket) {
      if (!ticket) {
        return 0
      }

      let quantity = 0
      const parterAsTicketEntry = this.parterAsTicket.find(t => t.id === ticket.id)
      if (parterAsTicketEntry) {
        quantity += this.elementDetails[ticket.id] || 0
      }

      for (const sectionSeatId of ticket.sectionSeats || []) {
        if (this.elementDetails[sectionSeatId]) {
          quantity += this.elementDetails[sectionSeatId]
        }
      }

      return quantity
    },
    getDialogElementCurrentQuantity() {
      if (!this.dialogElementId) {
        return 0
      }

      return this.elementDetails[this.dialogElementId] || 0
    },
    getDialogElementQuantityLimit(ticket) {
      return this.getMaxAllowedNonSeatQuantity(ticket, this.getDialogElementCurrentQuantity())
    },
    getMaxAllowedNonSeatQuantity(ticket, currentQuantity = 0) {
      const maxByOrder = Math.max(
        this.seatLimitPerOrder - (this.getNumOfSelectedElements() - currentQuantity),
        0,
      )
      const maxByItem =
        ticket && ticket.itemMeta && ticket.itemMeta.max
          ? Number(ticket.itemMeta.max)
          : Number.MAX_SAFE_INTEGER
      let maxByAvailability = Number.MAX_SAFE_INTEGER
      if (ticket && ticket.itemMeta && ticket.itemMeta.parter) {
        maxByAvailability = Number(ticket.quantity)
      } else if (this.isSharedTable(ticket) && this.dialogElementId) {
        const sharedTableAvailability =
          this.venueAvailability && this.venueAvailability[this.dialogElementId]
        maxByAvailability = Number((sharedTableAvailability && sharedTableAvailability.availableCount) || 0)
      }
      const maxByMembership =
        ticket && ticket.membership
          ? Math.max(
            this.membershipTicketLimit - (this.selectedMembershipTicketCount - currentQuantity),
            0,
          )
          : Number.MAX_SAFE_INTEGER

      return Math.min(maxByOrder, maxByItem, maxByAvailability, maxByMembership)
    },
    isSharedTable(ticket) {
      return !!(
        ticket &&
        ticket.itemMeta &&
        ticket.itemMeta.table &&
        ticket.itemMeta.sharedTable &&
        ticket.itemMeta.sharedTable.enabled
      )
    },
    getBundleOfferSelectionState(ticket) {
      if (!ticket || !ticket.bundleOffer || ticket.bundleOffer.availableQuantity <= 0) {
        return {
          paidCount: 0,
          selectedFreeCount: 0,
          entitledFreeCount: 0,
          pendingFreeCount: 0,
          excessFreeCount: 0,
        }
      }

      const paidCount = this.selectedTicket.filter(
        t => t.id === ticket.id && !t.bundleOfferId,
      ).length
      const selectedFreeCount = this.selectedTicket.filter(
        t => t.id === ticket.id && t.bundleOfferId === ticket.bundleOffer.id,
      ).length
      const possibleUsage = Math.floor(paidCount / ticket.bundleOffer.quantityInterval)
      const usage = Math.min(possibleUsage, ticket.bundleOffer.availableQuantity)
      const entitledFreeCount = usage * ticket.bundleOffer.freeQuantity

      return {
        paidCount,
        selectedFreeCount,
        entitledFreeCount,
        pendingFreeCount: Math.max(entitledFreeCount - selectedFreeCount, 0),
        excessFreeCount: Math.max(selectedFreeCount - entitledFreeCount, 0),
      }
    },
    hasSelectableGratisSeats(ticket) {
      if (!ticket || !ticket.bundleOffer || !ticket.sectionSeats || !ticket.sectionSeats.length) {
        return false
      }

      if (this.getNumOfSelectedElements() >= this.seatLimitPerOrder) {
        return false
      }

      return ticket.sectionSeats.some(seatId => {
        const seatAvailability = this.venueAvailability && this.venueAvailability[seatId]
        const isAvailable = seatAvailability && seatAvailability.state === this.seatState.AVAILABLE

        return isAvailable && !this.selectedSeatSet.has(seatId)
      })
    },
    shouldConsumeBundleGratis(ticket) {
      const { pendingFreeCount } = this.getBundleOfferSelectionState(ticket)

      return pendingFreeCount > 0
    },
    buildSelectedTicketForSeat(baseTicket) {
      if (!baseTicket) {
        return baseTicket
      }

      if (!this.shouldConsumeBundleGratis(baseTicket)) {
        return baseTicket
      }

      return {
        ...baseTicket,
        price: 0,
        bundleOfferId: baseTicket.bundleOffer.id,
      }
    },
    setSeatSelectionMeta(seat, ticket, extra = {}) {
      if (!seat || !ticket) {
        return
      }

      this.bundleOfferSelectionCounter += 1
      this.$set(this.seatSelectionMeta, seat, {
        ticketId: ticket.id,
        bundleOfferId: ticket.bundleOfferId || null,
        order: this.bundleOfferSelectionCounter,
        ...extra,
      })
    },
    clearSeatSelectionMeta(seat) {
      if (!seat || !this.seatSelectionMeta[seat]) {
        return
      }

      this.$delete(this.seatSelectionMeta, seat)
    },
    rebuildSeatSelectionMetaFromInitialState() {
      if (!this.initialSeatSelect || !this.initialSeatSelect.purchases || !this.initialValues) {
        return
      }

      const seatPurchases = this.initialSeatSelect.purchases.filter(
        p =>
          p &&
          p.accreditation &&
          p.accreditation.ticketLocation &&
          !(p.orderItem && p.orderItem.itemMeta && p.orderItem.itemMeta.parter),
      )
      if (!seatPurchases.length) {
        return
      }

      const availableTicketsByKey = {}
      this.initialValues.forEach(ticket => {
        const key = `${ticket.id}::${ticket.bundleOfferId || ''}`
        if (!availableTicketsByKey[key]) {
          availableTicketsByKey[key] = []
        }
        availableTicketsByKey[key].push(ticket)
      })

      seatPurchases.forEach(purchase => {
        const ticketId = purchase.orderItem && purchase.orderItem.id
        if (!ticketId) {
          return
        }

        const paidKey = `${ticketId}::`
        const exactKey =
          typeof purchase.bundleOfferId !== 'undefined' && purchase.bundleOfferId !== null
            ? `${ticketId}::${purchase.bundleOfferId}`
            : null
        const freeCandidateKey = Object.keys(availableTicketsByKey).find(key => {
          const [idPart, bundleOfferId] = key.split('::')

          return (
            Number(idPart) === Number(ticketId) &&
            !!bundleOfferId &&
            availableTicketsByKey[key].length
          )
        })

        const pickKey =
          (exactKey &&
            availableTicketsByKey[exactKey] &&
            availableTicketsByKey[exactKey].length &&
            exactKey) ||
          freeCandidateKey ||
          paidKey
        const pickedTicket =
          availableTicketsByKey[pickKey] && availableTicketsByKey[pickKey].shift()
        if (!pickedTicket) {
          return
        }

        this.setSeatSelectionMeta(purchase.accreditation.ticketLocation, pickedTicket)
      })
    },
    resetDeselectedSeatVisual(seat, svgDoc, fallbackTicket) {
      const seatElement = svgDoc.getElementById(seat)
      if (!seatElement) {
        return
      }

      if (this.isTheaterOrganization) {
        this.applyTheaterSeatVisual(seat, seatElement, fallbackTicket)

        return
      }

      if (!this.event.eventTemplateId) {
        const ticket = this.getFilteredOrderItemsForSeatId(seat)[0]
        if (ticket) {
          this.applyElementVisual(seatElement, ticket.color)
          seatElement.setAttribute('ticketId', ticket.id)
        } else {
          this.applyDisabledElementVisual(seatElement)
        }

        return
      }

      const currentTicket = this.getOrderItemById(this.currTicket)
      const currentTicketColor = currentTicket && currentTicket.color

      if (
        this.event.eventTemplateId &&
        fallbackTicket &&
        this.currTicket &&
        this.currTicket !== fallbackTicket.id
      ) {
        seatElement.style.fill = currentTicketColor
      } else {
        seatElement.removeAttribute('stroke')
        seatElement.style.fill = this.event.eventTemplateId ? '#979797' : fallbackTicket.color
      }

      seatElement.setAttribute(
        'fill',
        this.event.eventTemplateId &&
          this.currTicket &&
          fallbackTicket &&
          this.currTicket !== fallbackTicket.id
          ? currentTicketColor
          : fallbackTicket.color,
      )

      seatElement.setAttribute(
        'ticketId',
        this.event.eventTemplateId &&
          this.currTicket &&
          fallbackTicket &&
          this.currTicket !== fallbackTicket.id
          ? this.currTicket
          : fallbackTicket.id,
      )
    },
    isTopLevelSectionSeatId(seatId) {
      return typeof seatId === 'string' && seatId.startsWith('Section-') && !seatId.includes('_')
    },
    orderItemMatchesSeatId(orderItem, seatId) {
      if (!orderItem || !orderItem.sectionSeats || !seatId) {
        return false
      }

      if (orderItem.sectionSeats.includes(seatId)) {
        return true
      }

      if (!this.isTopLevelSectionSeatId(seatId)) {
        return false
      }

      return orderItem.sectionSeats.some(
        sectionSeatId =>
          typeof sectionSeatId === 'string' && sectionSeatId.startsWith(`${seatId}_`),
      )
    },
    orderItemIsSellable(orderItem) {
      return !!orderItem && (this.onlineSale || (!this.onlineSale && Number(orderItem.price) > 0))
    },
    getCurrentSeatOrderItem(seatTickets) {
      if (this.currTicket) {
        return this.getOrderItemById(this.currTicket)
      }

      return seatTickets && seatTickets.length ? seatTickets[0] : null
    },
    getSelectedSeatOrderItem(seat, seatElement, fallbackTicket) {
      const meta = this.seatSelectionMeta[seat]
      const ticketId =
        (meta && meta.ticketId) || (seatElement && seatElement.getAttribute('ticketId'))

      return this.getOrderItemById(ticketId) || fallbackTicket || null
    },
    isSeatAvailable(seat) {
      const seatAvailability = this.venueAvailability && this.venueAvailability[seat]

      return !!seatAvailability && seatAvailability.state === this.seatState.AVAILABLE
    },
    isSeatSellableForAnyOrderItem(seatTickets) {
      return (seatTickets || []).some(ticket => this.orderItemIsSellable(ticket))
    },
    applyElementVisual(element, fill, stroke = '', strokeWidth = '') {
      if (!element) {
        return
      }

      element.style.fill = fill
      element.setAttribute('fill', fill)
      element.style.cursor = 'pointer'
      element.removeAttribute('aria-disabled')

      if (stroke) {
        element.style.stroke = stroke
        element.setAttribute('stroke', stroke)
      } else {
        element.style.stroke = ''
        element.removeAttribute('stroke')
      }

      if (strokeWidth) {
        element.setAttribute('stroke-width', strokeWidth)
      } else {
        element.removeAttribute('stroke-width')
      }
    },
    getTheaterSeatVisual(seat, seatElement, fallbackTicket) {
      const currentTicket = this.getOrderItemById(this.currTicket)
      const seatTickets = this.getActiveOrderItemsForSeatId(seat)
      const selectedTicket = this.selectedSeatSet.has(seat)
        ? this.getSelectedSeatOrderItem(seat, seatElement, fallbackTicket || currentTicket)
        : null

      if (selectedTicket) {
        return {
          fill: selectedTicket.color,
          ticketId: selectedTicket.id,
          selected: true,
        }
      }

      // wheelchair-accessible seats are sold online only with an accessible ticket
      if (this.isWheelchairSeat(seat) && !this.currentTicketIsAccessible) {
        return {
          fill: '#F5F5F5',
          ticketId: null,
          selected: false,
        }
      }

      const isAvailable = this.isSeatAvailable(seat)
      const hasSellableSeatTicket = this.isSeatSellableForAnyOrderItem(seatTickets)
      if (!isAvailable || !hasSellableSeatTicket) {
        return {
          fill: '#F5F5F5',
          ticketId: null,
          selected: false,
        }
      }

      const currentTicketMatches =
        currentTicket &&
        this.orderItemIsSellable(currentTicket) &&
        this.orderItemMatchesSeatId(currentTicket, seat)

      if (currentTicketMatches) {
        return {
          fill: currentTicket.color,
          ticketId: currentTicket.id,
          selected: false,
        }
      }

      return {
        fill: '#D9D9D9',
        ticketId: null,
        selected: false,
      }
    },
    applyTheaterSeatVisual(seat, seatElement, fallbackTicket) {
      if (!seatElement) {
        return
      }

      const visual = this.getTheaterSeatVisual(seat, seatElement, fallbackTicket)

      this.applyElementVisual(
        seatElement,
        visual.fill,
        visual.selected ? '#333333' : '',
        visual.selected ? seatElement.getAttribute('stroke-width') || 2 : '',
      )
      this.updateWheelchairSeatIconContrast(seat, seatElement)

      if (visual.ticketId) {
        seatElement.setAttribute('ticketId', visual.ticketId)
      } else {
        seatElement.removeAttribute('ticketId')
        seatElement.style.cursor = 'default'
        seatElement.setAttribute('aria-disabled', 'true')
      }
    },
    getActiveOrderItemsForSeatId(seatId) {
      return this.activeOrderItemsBySeatId[seatId] || []
    },
    getFilteredOrderItemsForSeatId(seatId) {
      const tickets = this.getActiveOrderItemsForSeatId(seatId)

      return this.floorPlanTicketFilter === null
        ? tickets
        : tickets.filter(ticket => String(ticket.id) === String(this.floorPlanTicketFilter))
    },
    handleFloorPlanTicketFilter(ticketId) {
      this.floorPlanTicketFilter = ticketId
      this.hideSeatCard()
      this.hideSeatInfo()
      this.openFloorPlanElementDialog = false
      this.clearElementDetailsAndLocationInfo()
      if (this.event.eventTemplateId && ticketId !== null) {
        this.currTicket = ticketId
      }
      const svgDoc = this.getSvgDocument()
      if (!svgDoc) return
      this.handleSeatColoring(svgDoc)
      this.handleParterColoring(svgDoc)
    },
    removeExcessBundleGratisSelections(ticket, svgDoc) {
      if (!ticket || !ticket.bundleOffer) {
        return
      }

      const { excessFreeCount } = this.getBundleOfferSelectionState(ticket)
      if (excessFreeCount <= 0) {
        return
      }

      const freeSeatsForTicket = this.selectedSeats
        .filter(seat => {
          const meta = this.seatSelectionMeta[seat]

          return (
            meta &&
            meta.ticketId === ticket.id &&
            meta.bundleOfferId === ticket.bundleOffer.id &&
            svgDoc.getElementById(seat)
          )
        })
        .sort(
          (a, b) => (this.seatSelectionMeta[b].order || 0) - (this.seatSelectionMeta[a].order || 0),
        )
        .slice(0, excessFreeCount)

      freeSeatsForTicket.forEach(seat => {
        const seatTickets = this.getActiveOrderItemsForSeatId(seat)
        const fallbackTicket = this.event.eventTemplateId
          ? this.getOrderItemById(this.currTicket) || ticket
          : seatTickets[0] || ticket
        const removedTicket = {
          ...ticket,
          price: 0,
          bundleOfferId: ticket.bundleOffer.id,
        }

        this.selectedSeats = this.selectedSeats.filter(selectedSeat => selectedSeat !== seat)
        this.removeTicketFromCart(removedTicket, seat, svgDoc, { suppressParentReticket: true })
        this.resetDeselectedSeatVisual(seat, svgDoc, fallbackTicket)
        this.oneFreeSeatBetweenDeselectedSeatsCheck(seat, svgDoc)
      })
    },
    handleTicketClick(ticket) {
      if (this.isTheaterOrganization || this.event.eventTemplateId) {
        this.currTicket = ticket
        const svgDoc = this.getSvgDocument()
        this.handleSeatColoring(svgDoc)
      }
    },
    canAddMoreCheck() {
      return !(this.getNumOfSelectedElements() === this.seatLimitPerOrder)
    },
    oneFreeSeatBetweenSelectedSeatsCheck(seat, svgDoc) {
      if (this.requiredSeats.includes(seat)) {
        this.requiredSeats = this.requiredSeats.filter(reqSeat => reqSeat !== seat)
        this.addWhiteColorOnElementSelect(seat, svgDoc, this.currTicket)
      } else {
        const seatDetails = seat.split('_')
        const seatSection = seatDetails.find(sd => sd.includes('Section-'))
        const seatRow = seatDetails.find(sd => sd.includes('Row-'))
        const seatPosition = seatDetails.find(sp => sp.includes('Seat-'))
        const seatNumber = parseInt(seatPosition.split('-')[1])
        const rightSeatSpaceCheck =
          this.venueAvailability[`${seatSection}_${seatRow}_Seat-${seatNumber + 1}`] &&
          this.venueAvailability[`${seatSection}_${seatRow}_Seat-${seatNumber + 1}`].state ===
            this.seatState.AVAILABLE &&
          this.selectedSeats.includes(`${seatSection}_${seatRow}_Seat-${seatNumber + 2}`) &&
          !this.selectedSeats.includes(`${seatSection}_${seatRow}_Seat-${seatNumber + 1}`)
        const leftSeatSpaceCheck =
          this.venueAvailability[`${seatSection}_${seatRow}_Seat-${seatNumber - 1}`] &&
          this.venueAvailability[`${seatSection}_${seatRow}_Seat-${seatNumber - 1}`].state ===
            this.seatState.AVAILABLE &&
          this.selectedSeats.includes(`${seatSection}_${seatRow}_Seat-${seatNumber - 2}`) &&
          !this.selectedSeats.includes(`${seatSection}_${seatRow}_Seat-${seatNumber - 1}`)

        if (rightSeatSpaceCheck || leftSeatSpaceCheck) {
          if (rightSeatSpaceCheck) {
            this.requiredSeats.push(`${seatSection}_${seatRow}_Seat-${seatNumber + 1}`)
            svgDoc.getElementById(`${seatSection}_${seatRow}_Seat-${seatNumber + 1}`).style.fill =
              'red'
          }
          if (leftSeatSpaceCheck) {
            this.requiredSeats.push(`${seatSection}_${seatRow}_Seat-${seatNumber - 1}`)
            svgDoc.getElementById(`${seatSection}_${seatRow}_Seat-${seatNumber - 1}`).style.fill =
              'red'
          }
          this.snackbarColor = 'error'
          this.snackbarOpen = true
          this.snackbarMessage = { workflowCustomer: 'requiredSeatError', params: {} }
        }

        return rightSeatSpaceCheck || leftSeatSpaceCheck
      }
    },
    triggerButtonClick() {
      if (this.requiredSeats.length) {
        return
      }
      if (this.bundleOfferSubmitBlockState.blocked) {
        this.snackbarColor = 'error'
        this.snackbarOpen = true
        this.snackbarMessage = this.bundleOfferSubmitBlockState.message

        return
      }
      const seatMinViolation = this.orderItems.find(ticket => {
        if (
          !ticket.itemMeta ||
          !ticket.itemMeta.min ||
          ticket.itemMeta.table ||
          ticket.itemMeta.parter
        ) {
          return false
        }
        const count = this.selectedTicket.filter(t => t.id === ticket.id).length

        return count > 0 && count < Number(ticket.itemMeta.min)
      })
      if (seatMinViolation) {
        this.snackbarColor = 'error'
        this.snackbarOpen = true
        this.snackbarMessage = { workflowParts: ['', { workflowCustomer: 'chooseMinimum', params: {} }, ' ', seatMinViolation.itemMeta.min, ' ', Number(seatMinViolation.itemMeta.min) % 10 > 4 ? { workflowCustomer: 'tickets1', params: {} } : { workflowCustomer: 'tickets2', params: {} }, ''] }

        return
      }
      this.handleSubmit()
    },
    triggerMembershipClick(membershipNumber) {
      this.applyMembership(membershipNumber)
    },
    handleSubmit() {
      if (this.membership) {
        const orderItem = this.orderItems.find(oi =>
          this.membership.membershipPlan.orderItemTemplates.some(
            oit => oit.id === parseInt(oi.orderItemTemplateId),
          ),
        )
        if (!this.ticketLocations[orderItem.id]) {
          this.$emit('removePromoCode')
        }
      }
      const orderInfo = [...this.selectedSeats]
      if (Object.keys(this.elementDetails).length) {
        const svgDoc = this.getSvgDocument()
        for (const [key, value] of Object.entries(this.elementDetails)) {
          if (!svgDoc.getElementById(key)) {
            continue
          }
          const startFrom =
            this.getSvgElementType(svgDoc, key) === this.SvgElementCEType.TABLE ? 1 : 0
          for (let i = startFrom; i < value; i++) {
            orderInfo.push(key)
          }
        }
      }
      this.$emit('next', orderInfo)
    },
    oneFreeSeatBetweenDeselectedSeatsCheck(seat, svgDoc) {
      const seatDetails = seat.split('_')
      const seatSection = seatDetails.find(sd => sd.includes('Section-'))
      const seatRow = seatDetails.find(sd => sd.includes('Row-'))
      const seatPosition = seatDetails.find(sp => sp.includes('Seat-'))
      const seatNumber = parseInt(seatPosition.split('-')[1])
      const rightSeatSpaceCheck = this.selectedSeats.includes(
        `${seatSection}_${seatRow}_Seat-${seatNumber + 1}`,
      )
      const leftSeatSpaceCheck = this.selectedSeats.includes(
        `${seatSection}_${seatRow}_Seat-${seatNumber - 1}`,
      )
      const removeSeatsFromRequired = this.requiredSeats.filter(
        rs =>
          rs === `${seatSection}_${seatRow}_Seat-${seatNumber + 1}` ||
          rs === `${seatSection}_${seatRow}_Seat-${seatNumber - 1}`,
      )
      removeSeatsFromRequired.map(s => {
        const seatElement = svgDoc.getElementById(s)
        if (this.isTheaterOrganization) {
          this.applyTheaterSeatVisual(s, seatElement)
        } else {
          seatElement.style.fill = this.event.eventTemplateId
            ? '#979797'
            : this.orderItems.find(oi => oi.sectionSeats.includes(s)).color
        }
        this.requiredSeats.splice(this.requiredSeats.indexOf(s), 1)
      })

      if (rightSeatSpaceCheck && leftSeatSpaceCheck) {
        this.requiredSeats.push(seat)
        svgDoc.getElementById(seat).style.fill = 'red'

        this.snackbarColor = 'error'
        this.snackbarOpen = true
        this.snackbarMessage = { workflowCustomer: 'requiredSeatError', params: {} }
      }

      return rightSeatSpaceCheck || leftSeatSpaceCheck
    },
    addPromo() {
      return (this.selectPromo = !this.selectPromo)
    },
    getCurrZoom() {
      return window.panZoom.getZoom()
    },
    applyPromoCode(promoCodeInput) {
      this.$emit('applyPromo', promoCodeInput)
    },
    applyMembership(membershipInput) {
      this.snackbarColor = 'primary'
      this.snackbarOpen = true
      this.snackbarMessage = 'workflowsAll.vase_clanstvo_ukljucuje_ulaznice_po_povlasten_58e2771'
      this.$emit('applyMembership', membershipInput)
      this.addMembershipOrderItem(membershipInput)
    },
    addMembershipOrderItem(membershipInput) {
      const membershipTicket = this.allOrderItems.find(oi =>
        membershipInput.membershipPlan.orderItemTemplates.some(
          oit => oit.id === parseInt(oi.orderItemTemplateId),
        ),
      )

      if (!membershipTicket) return
      this.orderItems = [
        ...this.orderItems,
        {
          ...membershipTicket,
          displayTicketLabel: `
            <div style="display: inline-flex; align-items: center;">
              <span style="
                display: inline-block;
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: ${membershipTicket.color};
                margin-right: 8px;">
              </span>
              <strong>${membershipTicket.name} - ${membershipTicket.price} ${membershipTicket.currency}</strong>
            </div>
          `,
        },
      ]

      setTimeout(() => {
        this.handleTicketClick(membershipTicket.id)
      }, 10)
    },

    removePromoCode() {
      if (this.membership) {
        const svgDoc = this.getSvgDocument()
        const membershipOrderItem = this.allOrderItems.find(oi =>
          this.membership.membershipPlan.orderItemTemplates.some(
            oit => oit.id === parseInt(oi.orderItemTemplateId),
          ),
        )
        this.currTicket = membershipOrderItem.id
        const removeSeatIds = []
        if (this.ticketLocations[membershipOrderItem.id]) {
          this.ticketLocations[membershipOrderItem.id].map(location => {
            location.seats.map(seat => {
              const seatId = `${location.section}_${location.row}_Seat-${seat}`
              removeSeatIds.push(seatId)
              const seatElement = svgDoc.getElementById(seatId)
              seatElement.removeAttribute('stroke')
              if (this.isTheaterOrganization) {
                this.applyTheaterSeatVisual(seatId, seatElement, membershipOrderItem)
              } else {
                seatElement.style.fill = '#979797'
              }
              this.selectedSeats = this.selectedSeats.filter(seat => seat !== seatId)
            })
          })
        }
        removeSeatIds.map(id => this.removeTicketFromCart(membershipOrderItem, id, svgDoc))
        this.orderItems = this.orderItems.filter(
          oi =>
            !this.membership.membershipPlan.orderItemTemplates
              .map(oit => oit.id)
              .includes(parseInt(oi.orderItemTemplateId)),
        )
        this.selectedTicket = this.selectedTicket.filter(
          oi =>
            !this.membership.membershipPlan.orderItemTemplates
              .map(oit => oit.id)
              .includes(parseInt(oi.orderItemTemplateId)),
        )
        this.handleTicketClick(this.orderItems[0].id)
      }
      this.$emit('removePromoCode')
    },
    isArenaSectionColorVenue() {
      return (
        !!this.venue &&
        [
          Venue.ARENA_ZAGREB,
          'Arena Zagreb 2',
          Venue.ARENA_ZAGREB_PARTER_EXTENDED,
          Venue.ARENA_ZAGREB_PARTER_A_B,
          Venue.ARENA_ZAGREB_STOLOVI_FAN_PIT_BEZ_GORNJIH_SEKTORA,
        ].includes(this.venue.name)
      )
    },
    isArenaFanPitVenue() {
      return (
        !!this.venue &&
        [
          Venue.ARENA_ZAGREB_STOLOVI_FAN_PIT,
          Venue.ARENA_ZAGREB_STOLOVI_FAN_PIT_BEZ_GORNJIH_SEKTORA,
        ].includes(this.venue.name)
      )
    },
    isArenaFanPitTopLevelSectionElement(seatId) {
      return this.isArenaFanPitVenue() && this.isTopLevelSectionSeatId(seatId)
    },
    isArenaAutoZoomVenue() {
      if (!this.venue) {
        return false
      }

      return (
        (!this.isArenaFanPitVenue() && this.venue.name.includes(Venue.ARENA_ZAGREB)) ||
        this.venue.name === Venue.ARENA_ZAGREB_STOLOVI_FAN_PIT_BEZ_GORNJIH_SEKTORA
      )
    },
    getArenaSectionColorZoomLimit() {
      return 1.9
    },
    applyDisabledElementVisual(element) {
      if (!element) {
        return
      }

      element.style.fill = this.disabledSeatFill
      element.setAttribute('fill', this.disabledSeatFill)
      element.style.stroke = this.disabledSeatFill
      element.setAttribute('stroke', this.disabledSeatFill)
      element.style.cursor = 'default'
      element.setAttribute('aria-disabled', 'true')
    },
    getArenaSectionChildSeats(sectionId) {
      return this.arenaSectionChildSeatsMap[sectionId] || []
    },
    getArenaSectionPrimaryTicket(sectionId) {
      return this.getFilteredOrderItemsForSeatId(sectionId).find(
        ticket => this.onlineSale || (!this.onlineSale && Number(ticket.price) > 0),
      )
    },
    isArenaSectionAvailable(sectionId) {
      return this.getArenaSectionChildSeats(sectionId).some(seatId => {
        const seatAvailability = this.venueAvailability && this.venueAvailability[seatId]
        const seatTickets = this.getFilteredOrderItemsForSeatId(seatId)
        const hasSellableSeatTicket = seatTickets.some(
          ticket => this.onlineSale || (!this.onlineSale && Number(ticket.price) > 0),
        )

        return (
          seatAvailability &&
          seatAvailability.state === this.seatState.AVAILABLE &&
          hasSellableSeatTicket
        )
      })
    },
    getArenaSectionVisual(sectionId, currZoom, zoomLimit = 1) {
      const primaryTicket = this.getArenaSectionPrimaryTicket(sectionId)
      const isAvailable = this.isArenaSectionAvailable(sectionId)

      if (!primaryTicket || !isAvailable) {
        return {
          fill: this.floorPlanTicketFilter !== null ? this.disabledSeatFill : '#F5F5F5',
          fillOpacity: 1,
        }
      }

      if (Number(currZoom) <= zoomLimit) {
        return {
          fill: primaryTicket.color,
          fillOpacity: 0.3,
        }
      }

      return {
        fill: 'white',
        fillOpacity: 1,
      }
    },
    rebuildArenaSectionVisualCache(svgDoc, currZoom = this.getCurrZoom(), zoomLimit = 1) {
      if (!this.isArenaSectionColorVenue() || !svgDoc) {
        return
      }

      this.arenaSectionVisualCache = this.venue.seats
        .filter(sectionId => this.isTopLevelSectionSeatId(sectionId))
        .map(sectionId => {
          const sectionElement = svgDoc.getElementById(sectionId)
          if (!sectionElement) {
            return null
          }

          const zoomedOutVisual = this.getArenaSectionVisual(sectionId, zoomLimit, zoomLimit)
          const zoomedInVisual = this.getArenaSectionVisual(sectionId, currZoom + 1, zoomLimit)

          return {
            sectionElement,
            zoomedOutVisual,
            zoomedInVisual,
          }
        })
        .filter(Boolean)

      this.arenaSectionZoomState = null
    },
    applyArenaSectionZoomColors(svgDoc, currZoom = this.getCurrZoom(), zoomLimit = 1) {
      if (!this.isArenaSectionColorVenue() || !svgDoc) {
        return
      }

      if (!this.arenaSectionVisualCache.length) {
        this.rebuildArenaSectionVisualCache(svgDoc, currZoom, zoomLimit)
      }

      const nextZoomState = Number(currZoom) <= zoomLimit ? 'zoomed-out' : 'zoomed-in'
      if (this.arenaSectionZoomState === nextZoomState) {
        return
      }

      this.arenaSectionVisualCache.forEach(
        ({ sectionElement, zoomedOutVisual, zoomedInVisual }) => {
          const { fill, fillOpacity } =
            nextZoomState === 'zoomed-out' ? zoomedOutVisual : zoomedInVisual

          sectionElement.style.fill = fill
          sectionElement.style.fillOpacity = fillOpacity
          sectionElement.setAttribute('fill', fill)
          sectionElement.setAttribute('fill-opacity', fillOpacity)
        },
      )

      this.arenaSectionZoomState = nextZoomState
    },
    hideSeatsAtSpecificZoom(zoomLimit, currZoom, svgDoc) {
      if (!this.isArenaSectionColorVenue()) {
        return
      }

      const svgDocument = svgDoc || this.getSvgDocument()

      if (!svgDocument) {
        return
      }

      this.applyArenaSectionZoomColors(svgDocument, currZoom, zoomLimit)
    },
    checkZoomButtonsState(isZoomingIn, zoomLevel) {
      if (!this.isTheaterOrganization) {
        const zoom = typeof zoomLevel === 'number' ? zoomLevel : this.getCurrZoom()
        this.zoomInIconColor = zoom >= this.maxZoom - 0.01 ? '#D9D9D9' : '#0277BD'
        this.zoomOutIconColor = zoom <= this.floorPlanMinZoom + 0.01 ? '#D9D9D9' : '#0277BD'

        return
      }
      if (isZoomingIn) {
        if (this.getCurrZoom() >= this.maxZoom - 0.1) {
          this.zoomInIconColor = '#D9D9D9'
        }
        if (this.getCurrZoom() > 0.51) {
          this.zoomOutIconColor = '#0277BD'
        }
      } else {
        if (this.getCurrZoom() <= this.maxZoom - 0.1) {
          this.zoomInIconColor = '#0277BD'
        }
        if (this.getCurrZoom() <= 0.51) {
          this.zoomOutIconColor = '#D9D9D9'
        }
      }
    },
    setZoomButtonsActions(svgDoc) {
      document.getElementById('zoomIn').addEventListener(
        this.isTheaterOrganization ? this.eventListenerType[this.isMobile] : 'click',
        function () {
          window.panZoom.zoomIn()
          this.checkZoomButtonsState(true, svgDoc)
          this.hideSeatsAtSpecificZoom(
            this.getArenaSectionColorZoomLimit(),
            this.getCurrZoom(),
            svgDoc,
          )
        }.bind(this),
      )
      document.getElementById('zoomOut').addEventListener(
        this.isTheaterOrganization ? this.eventListenerType[this.isMobile] : 'click',
        function () {
          window.panZoom.zoomOut()
          this.checkZoomButtonsState(false, svgDoc)
          this.hideSeatsAtSpecificZoom(
            this.getArenaSectionColorZoomLimit(),
            this.getCurrZoom(),
            svgDoc,
          )
        }.bind(this),
      )
      document.getElementById('resetZoom').addEventListener(
        this.isTheaterOrganization ? this.eventListenerType[this.isMobile] : 'click',
        function () {
          window.panZoom.resetZoom().zoomOut()
          window.panZoom.center()
          this.zoomInIconColor = '#0277BD'
          this.zoomOutIconColor = '#0277BD'
          if (!this.isTheaterOrganization) this.checkZoomButtonsState()
          this.hideSeatsAtSpecificZoom(
            this.getArenaSectionColorZoomLimit(),
            this.getCurrZoom(),
            svgDoc,
          )
        }.bind(this),
      )
    },
    addWhiteColorOnElementSelect(seat, svgDoc, orderItemId) {
      const selectedElement = svgDoc.getElementById(seat)
      if (!selectedElement) {
        return
      }

      const orderItem = this.getOrderItemById(orderItemId)
      let strokeWidth = 2
      if (selectedElement.hasAttribute('r')) {
        strokeWidth = Number(selectedElement.getAttribute('r')) * 0.4
      }
      const fillColor =
        (this.isTheaterOrganization || this.event.eventTemplateId) && orderItem
          ? orderItem.color
          : 'white'
      selectedElement.style.fill = fillColor
      selectedElement.setAttribute('fill', fillColor)
      selectedElement.setAttribute('stroke', '#333333')
      selectedElement.setAttribute('stroke-width', strokeWidth)
      this.updateWheelchairSeatIconContrast(seat, selectedElement)
    },
    removeTicketFromCart(ticket, seat, svgDoc, options = {}) {
      const seatElement = svgDoc.getElementById(seat)
      const seatMeta = this.seatSelectionMeta[seat]
      const currentTicket = this.getOrderItemById(this.currTicket)
      const seatHasSameColorAsCurrTicket =
        this.isTheaterOrganization || this.event.eventTemplateId
          ? seatElement.getAttribute('fill') === (currentTicket && currentTicket.color)
          : false
      let index = this.selectedTicket.findIndex(item => {
        if (item.id !== ticket.id) {
          return false
        }

        if (seatMeta && typeof seatMeta.bundleOfferId !== 'undefined') {
          return (item.bundleOfferId || null) === (seatMeta.bundleOfferId || null)
        }

        if (ticket.bundleOfferId) {
          return item.bundleOfferId === ticket.bundleOfferId
        }

        return !item.bundleOfferId
      })
      if (index === -1) {
        index = this.selectedTicket.findIndex(item => item.id === ticket.id)
      }
      if (index === -1) {
        return
      }
      const removedTicket = index !== -1 ? this.selectedTicket[index] : ticket
      this.selectedTicket.splice(index, 1)
      const oldTicketId = seatElement.getAttribute('ticketId')
      const oldTicket = this.getOrderItemById(oldTicketId)
      this.clearSeatSelectionMeta(seat)
      if (ticket.itemMeta.table) {
        this.$emit('removeSelectedTableTickets', [
          ticket,
          seat,
          seatHasSameColorAsCurrTicket,
          oldTicket,
          this.elementDetails,
        ])
        delete this.elementDetails[seat]
      } else {
        this.$emit('removeSelectedTickets', [
          ticket,
          seat,
          seatHasSameColorAsCurrTicket,
          oldTicket
            ? { ...oldTicket, bundleOfferId: removedTicket.bundleOfferId }
            : { ...ticket, bundleOfferId: removedTicket.bundleOfferId },
          !!options.suppressParentReticket,
        ])
      }
    },
    addTicketToCart(ticket, seat) {
      const baseTicket = this.getOrderItemById(
        this.isTheaterOrganization || this.event.eventTemplateId ? this.currTicket : ticket.id,
      )
      if (
        baseTicket &&
        baseTicket.membership &&
        this.selectedMembershipTicketCount + 1 > this.membershipTicketLimit
      ) {
        return
      }

      const addTicket = this.buildSelectedTicketForSeat(baseTicket)
      this.selectedTicket.push(addTicket)
      this.setSeatSelectionMeta(seat, addTicket)
      this.$emit('addSelectedTickets', [addTicket, seat])
    },
    isWheelchairSeat(seat) {
      return !!this.wheelchairSeats[seat]
    },
    wheelchairSeatIconId(seat) {
      return `wheelchair-icon-${seat}`
    },
    // paints the ♿ figure onto every wheelchair seat; in the SVG they are regular seats,
    // the pairing lives in venue.wheelchairSeats
    renderWheelchairSeatIcons(svgDoc) {
      const wheelchairSeatIds = Object.keys(this.wheelchairSeats)
      if (!wheelchairSeatIds.length) {
        return
      }
      const svgNamespace = 'http://www.w3.org/2000/svg'
      wheelchairSeatIds.forEach(seat => {
        const seatElement = svgDoc.getElementById(seat)
        if (!seatElement || svgDoc.getElementById(this.wheelchairSeatIconId(seat))) {
          return
        }
        // getBBox() is in the element's local space - map its centre through the seat's own
        // transform (some halls place seats via transform matrices)
        const bbox = seatElement.getBBox()
        let centerX = bbox.x + bbox.width / 2
        let centerY = bbox.y + bbox.height / 2
        let transformScale = 1
        const transformList = seatElement.transform && seatElement.transform.baseVal
        const consolidated =
          transformList && transformList.numberOfItems ? transformList.consolidate() : null
        if (consolidated) {
          const matrix = consolidated.matrix
          const transformedX = matrix.a * centerX + matrix.c * centerY + matrix.e
          const transformedY = matrix.b * centerX + matrix.d * centerY + matrix.f
          centerX = transformedX
          centerY = transformedY
          transformScale = Math.sqrt(Math.abs(matrix.a * matrix.d - matrix.b * matrix.c)) || 1
        }
        const iconSize = Math.min(bbox.width, bbox.height) * transformScale * 0.72
        const icon = svgDoc.createElementNS(svgNamespace, 'path')
        icon.setAttribute('id', this.wheelchairSeatIconId(seat))
        // material icons "accessible" glyph, 24x24 viewBox
        icon.setAttribute(
          'd',
          'M12 4a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm7 9v-2c-1.54.02-3.09-.75-4.07-1.83l-1.29-1.43c-.17-.19-.38-.34-.61-.45-.01 0-.01-.01-.02-.01H13c-.35-.2-.75-.3-1.19-.26C10.76 7.11 10 8.04 10 9.09V15c0 1.1.9 2 2 2h5v5h2v-5.5c0-1.1-.9-2-2-2h-3v-3.45c1.29 1.07 3.25 1.94 5 1.95zm-6.17 5c-.41 1.16-1.52 2-2.83 2-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1a5 5 0 1 0 5.9 5.9h-2.07z',
        )
        icon.setAttribute(
          'transform',
          `translate(${centerX - iconSize / 2}, ${centerY - iconSize / 2}) scale(${iconSize / 24})`,
        )
        icon.setAttribute('pointer-events', 'none')
        seatElement.parentNode.appendChild(icon)
        this.updateWheelchairSeatIconContrast(seat, seatElement)
      })
    },
    updateWheelchairSeatIconContrast(seat, seatElement) {
      if (!seatElement || !this.isWheelchairSeat(seat)) {
        return
      }
      const icon = seatElement.ownerDocument.getElementById(this.wheelchairSeatIconId(seat))
      if (!icon) {
        return
      }
      const iconFill = this.isLightFillColor(seatElement.getAttribute('fill'))
        ? '#333333'
        : '#FFFFFF'
      icon.setAttribute('fill', iconFill)
      icon.style.fill = iconFill
    },
    isLightFillColor(color) {
      if (!color || color === 'white') {
        return true
      }
      const hex = color.replace('#', '')
      if (hex.length !== 3 && hex.length !== 6) {
        return true
      }
      const fullHex =
        hex.length === 3
          ? hex
            .split('')
            .map(char => char + char)
            .join('')
          : hex
      const red = parseInt(fullHex.slice(0, 2), 16)
      const green = parseInt(fullHex.slice(2, 4), 16)
      const blue = parseInt(fullHex.slice(4, 6), 16)

      return (0.299 * red + 0.587 * green + 0.114 * blue) / 255 > 0.6
    },
    // every accessible ticket type has its own free escort ("Pratnja") item sharing its template
    escortOrderItemFor(accessibleTicket) {
      if (!accessibleTicket || !accessibleTicket.orderItemTemplateId) {
        return null
      }

      return (
        (this.orderItems || []).find(
          ticket =>
            ticket.itemMeta &&
            ticket.itemMeta.isEscort &&
            String(ticket.orderItemTemplateId) === String(accessibleTicket.orderItemTemplateId),
        ) || null
      )
    },
    parseFloorPlanSeatId(seatId) {
      const match = /^Section-(.+)_Row-(.+)_Seat-(\d+)$/.exec(seatId || '')
      if (!match) {
        return null
      }

      return { section: match[1], row: match[2], seat: Number(match[3]) }
    },
    // the escort sits on a companion seat of a wheelchair seat, or immediately right/left
    // (same section and row, seat number ±1) of a regular seat - right neighbour preferred
    findEscortSeatFor(anchorSeat, escortTicket) {
      if (!escortTicket) {
        return null
      }
      let candidates = []
      if (this.isWheelchairSeat(anchorSeat)) {
        candidates = this.wheelchairSeats[anchorSeat] || []
      } else {
        const parsed = this.parseFloorPlanSeatId(anchorSeat)
        if (!parsed) {
          return null
        }
        candidates = [
          `Section-${parsed.section}_Row-${parsed.row}_Seat-${parsed.seat + 1}`,
          `Section-${parsed.section}_Row-${parsed.row}_Seat-${parsed.seat - 1}`,
        ]
      }

      return (
        candidates.find(
          seat =>
            seat !== anchorSeat &&
            !this.isWheelchairSeat(seat) &&
            !this.selectedSeatSet.has(seat) &&
            this.isSeatAvailable(seat) &&
            escortTicket.sectionSeats.includes(seat),
        ) || null
      )
    },
    shouldShowEscortQuestion(seat, orderItem) {
      if (!orderItem || !orderItem.itemMeta || !orderItem.itemMeta.isAccessible) {
        return false
      }
      const escortTicket = this.escortOrderItemFor(orderItem)
      if (!escortTicket || !this.findEscortSeatFor(seat, escortTicket)) {
        return false
      }

      // the accessible seat and its escort together take two spots of the per-order limit
      return this.getNumOfSelectedElements() + 2 <= this.seatLimitPerOrder
    },
    addEscortSeatToCart(anchorSeat, svgDoc, accessibleTicket) {
      const escortTicket = this.escortOrderItemFor(accessibleTicket)
      const escortSeat = this.findEscortSeatFor(anchorSeat, escortTicket)
      if (!escortSeat) {
        return
      }

      this.selectedSeats.push(escortSeat)
      this.selectedTicket.push(escortTicket)
      this.setSeatSelectionMeta(escortSeat, escortTicket, { escortOf: anchorSeat })
      this.$emit('addSelectedTickets', [escortTicket, escortSeat])

      const escortElement = svgDoc.getElementById(escortSeat)
      if (escortElement) {
        this.addWhiteColorOnElementSelect(escortSeat, svgDoc, escortTicket.id)
        escortElement.setAttribute('ticketId', escortTicket.id)
      }
      this.canAddMoreTickets = this.canAddMoreCheck()
    },
    removeEscortSeat(seat, svgDoc) {
      const meta = this.seatSelectionMeta[seat]
      const escortTicket = meta && this.getOrderItemById(meta.ticketId)
      if (!escortTicket || !(escortTicket.itemMeta && escortTicket.itemMeta.isEscort)) {
        return
      }
      const index = this.selectedSeats.indexOf(seat)
      if (index !== -1) {
        this.selectedSeats.splice(index, 1)
      }
      // never re-ticket the freed seat to the currently selected ticket type - this removal is
      // driven by the escort pairing, not by a regular seat swap
      this.removeTicketFromCart(escortTicket, seat, svgDoc, { suppressParentReticket: true })
      this.resetDeselectedSeatVisual(seat, svgDoc, escortTicket)
      this.canAddMoreTickets = this.canAddMoreCheck()
    },
    // an escort ticket lives and dies with the accessible seat it was added for
    removeEscortSeatFor(anchorSeat, svgDoc) {
      const escortSeat = Object.keys(this.seatSelectionMeta).find(
        seat =>
          this.seatSelectionMeta[seat] && this.seatSelectionMeta[seat].escortOf === anchorSeat,
      )
      if (escortSeat) {
        this.removeEscortSeat(escortSeat, svgDoc)
      }
    },
    addParterAsTicketToCart(ticket) {
      const currentQuantity = this.elementDetails[ticket.id] || 0
      const candidateQuantity = currentQuantity + 1
      const maxAllowedQuantity = this.getMaxAllowedNonSeatQuantity(ticket, currentQuantity)
      if (candidateQuantity > maxAllowedQuantity) {
        return
      }

      const nextQuantity = this.getBundleAdjustedNonSeatQuantity(ticket, candidateQuantity, 'up')
      const finalQuantity = nextQuantity <= maxAllowedQuantity ? nextQuantity : candidateQuantity
      this.$set(this.elementDetails, ticket.id, finalQuantity)
      const totalQuantityForTicketId = this.getNonSeatSelectedQuantityForTicket(ticket)
      this.replaceSelectedTicketsForOrderItem(
        ticket,
        this.buildSelectedTicketsForNonSeatQuantity(ticket, totalQuantityForTicketId),
      )
      this.$emit('addDialogElementToOrder', [
        ticket,
        finalQuantity,
        TicketType.REGULAR,
        null,
        { totalQuantityForTicketId },
      ])
      this.canAddMoreTickets = this.canAddMoreCheck()
    },
    removeParterAsTicketToCart(ticket) {
      if (!this.elementDetails[ticket.id]) {
        delete this.elementDetails[ticket.id]
      } else {
        const nextQuantity = this.getBundleAdjustedNonSeatQuantity(
          ticket,
          Math.max(this.elementDetails[ticket.id] - 1, 0),
          'down',
        )
        if (nextQuantity > 0) {
          this.$set(this.elementDetails, ticket.id, nextQuantity)
        } else {
          this.$delete(this.elementDetails, ticket.id)
        }
      }
      const totalQuantityForTicketId = this.getNonSeatSelectedQuantityForTicket(ticket)
      this.replaceSelectedTicketsForOrderItem(
        ticket,
        this.buildSelectedTicketsForNonSeatQuantity(ticket, totalQuantityForTicketId),
      )
      this.$emit('addDialogElementToOrder', [
        ticket,
        this.elementDetails[ticket.id] || 0,
        TicketType.REGULAR,
        null,
        { totalQuantityForTicketId },
      ])
      this.canAddMoreTickets = this.canAddMoreCheck()
    },
    handleTriggerTableTicketDialog(orderItem, seat) {
      if (orderItem.itemMeta.table) {
        this.switchElementDialogState()
        this.dialogElement = orderItem
        this.dialogElementId = seat
        this.initialFloorPlanDialogElementQuantity = this.isSharedTable(orderItem)
          ? orderItem.itemMeta.sharedTable.allowedQuantities[0]
          : orderItem.itemMeta.min
      }
    },
    switchElementDialogState() {
      this.openFloorPlanElementDialog = !this.openFloorPlanElementDialog
    },
    getSvgElementType(svgDoc, id) {
      const element = svgDoc.getElementById(id)

      return element && element.getAttribute('ce-type')
    },
    getSvgClickableElementId(svgDoc, target) {
      if (!this.isArenaFanPitVenue()) {
        return (target && target.id) || ''
      }

      let currentElement = target
      while (currentElement && currentElement !== svgDoc) {
        const elementId = currentElement.id
        if (elementId && this.getSvgElementType(svgDoc, elementId)) {
          return elementId
        }
        currentElement = currentElement.parentElement
      }

      return (target && target.id) || ''
    },
    handleParterClicked(svgDoc, parterId) {
      const parterOrderItem = this.getFilteredOrderItemsForSeatId(parterId).find(
        oi => oi.itemMeta.parter && oi.sectionSeats.includes(parterId),
      )
      if (!parterOrderItem) {
        return
      }
      if (
        Number(parterOrderItem.quantity) <= 0 ||
        (this.getNumOfSelectedElements() >= this.seatLimitPerOrder &&
          !this.elementDetails[parterId])
      ) {
        return
      }
      this.initialFloorPlanDialogElementQuantity = this.elementDetails[parterId] || 1
      this.switchElementDialogState()
      this.dialogElement = parterOrderItem
      this.dialogElementId = parterId
    },
    initialSvgColors(svgDoc) {
      const svgObject = this.getSvgObject()
      const svgContentDocument = svgObject && svgObject.contentDocument
      const svgRootElement = svgDoc.getElementById('svgfile')
      if (!svgContentDocument || !svgRootElement) {
        return
      }

      svgRootElement.style.touchAction = 'none'
      const delta = 6
      let startX
      let startY
      let multiTouch = false
      svgRootElement.addEventListener(
        this.isMobile ? 'touchstart' : 'mousedown',
        function (e) {
          if (this.isMobile) {
            multiTouch = e.touches.length > 1
            startY = e.touches[0].clientY
            startX = e.touches[0].clientX
          } else {
            startY = e.pageY
            startX = e.pageX
          }
        }.bind(this),
      )

      if (this.isZkm) {
        svgContentDocument.addEventListener(this.isMobile ? '' : 'mouseover', e => {
          const target = e.target
          if (target.id.includes('Row-') && !target.getAttribute('sold')) {
            this.showSeatInfo(target.id, e)
          } else {
            this.hideSeatInfo()
          }
        })

        svgContentDocument.addEventListener(this.isMobile ? '' : 'mouseout', e => {
          if (!e.relatedTarget || !e.relatedTarget.id.includes('Row-')) {
            this.hideSeatInfo()
          }
        })
      }

      if (!this.isMobile && !this.disableSeatHoverDetails) {
        svgContentDocument.addEventListener('mouseover', e => {
          if (this.seatCardState === 'click') return
          const seatId = e.target.id
          if (!seatId || !seatId.includes('Row-') || !seatId.includes('Seat-')) {
            if (this.seatCardState === 'hover' || this.seatCardState === 'added') {
              this.hideSeatCard()
            }

            return
          }
          const seatTickets = this.getFilteredOrderItemsForSeatId(seatId)
          if (!seatTickets.length) {
            if (this.seatCardState === 'hover' || this.seatCardState === 'added') {
              this.hideSeatCard()
            }

            return
          }
          const orderItem =
            this.isTheaterOrganization || this.event.eventTemplateId
              ? this.getCurrentSeatOrderItem(seatTickets)
              : seatTickets[0]
          if (!orderItem) {
            return
          }
          if (this.isTheaterOrganization && !this.orderItemMatchesSeatId(orderItem, seatId)) {
            return
          }
          const coords = this.svgEventToViewportCoords(e)
          if (!coords) {
            return
          }

          if (this.selectedSeatSet.has(seatId)) {
            this.hideSeatCard()

            return
          }

          const targetType = this.getSvgElementType(svgDoc, seatId)
          if (targetType === SvgElementCEType.PARTER) {
            if (
              Number(orderItem.quantity) <= 0 ||
              this.selectedTicket.find(t => t.id === orderItem.id)
            ) {
              return
            }

            this.showSeatCard(seatId, orderItem, coords.x, coords.y, 'hover')

            return
          }

          const seatAvail = this.venueAvailability && this.venueAvailability[seatId]
          if (!seatAvail || seatAvail.state !== this.seatState.AVAILABLE) {
            return
          }
          this.showSeatCard(seatId, orderItem, coords.x, coords.y, 'hover')
        })

        svgContentDocument.addEventListener('mouseout', e => {
          if (this.seatCardState !== 'hover' && this.seatCardState !== 'added') return
          const relatedId = e.relatedTarget && e.relatedTarget.id
          if (relatedId && relatedId.includes('Row-') && relatedId.includes('Seat-')) return
          this.hideSeatCard()
        })
      }

      svgContentDocument.addEventListener(
        this.isMobile ? 'touchend' : 'mouseup',
        function (e) {
          const seatCheck = ['Seat-', 'Row-']
          // Keep enough surrounding context visible while making the child elements
          // selectable. The previous 6.1x target was just below that usable level.
          const arenaAutoZoomLevel = Math.min(6.5, this.maxZoom)
          const clickedElement = this.getSvgClickableElementId(svgDoc, e.target)
          const clickedElementType = this.getSvgElementType(svgDoc, clickedElement)
          if (
            this.floorPlanTicketFilter !== null &&
            !this.getFilteredOrderItemsForSeatId(clickedElement).length
          ) {
            this.hideSeatCard()

            return
          }
          const isSeatClick = clickedElementType === SvgElementCEType.REGULAR
          const isParterClick = clickedElementType === SvgElementCEType.PARTER
          const isTableClick = clickedElementType === SvgElementCEType.TABLE
          const diffX = Math.abs(
            this.isMobile ? e.changedTouches[0].clientX - startX : e.pageX - startX,
          )
          const diffY = Math.abs(
            this.isMobile ? e.changedTouches[0].clientY - startY : e.pageY - startY,
          )
          if (
            !multiTouch &&
            diffX < delta &&
            diffY < delta &&
            this.isArenaAutoZoomVenue() &&
            // Parter areas are selectable at any zoom level.
            !isParterClick &&
            this.getCurrZoom() < arenaAutoZoomLevel - 0.01
          ) {
            window.panZoom.zoomAtPoint(arenaAutoZoomLevel, {
              x: startX,
              y: startY,
            })

            return
          }
          if (
            !multiTouch &&
            diffX < delta &&
            diffY < delta &&
            !isSeatClick &&
            !isParterClick &&
            !isTableClick
          ) {
            this.hideSeatCard()
          }
          if (!multiTouch && diffX < delta && diffY < delta && isTableClick) {
            this.hideSeatCard()
          }
          if (!multiTouch && diffX < delta && diffY < delta && isParterClick) {
            this.hideSeatCard()
            this.handleParterClicked(svgDoc, clickedElement)

            return
          }
          if (
            !multiTouch &&
            diffX < delta &&
            diffY < delta &&
            seatCheck.every(check => clickedElement.includes(check))
          ) {
            const seat = clickedElement
            const seatTickets = this.getFilteredOrderItemsForSeatId(seat)
            const seatElement = svgDoc.getElementById(seat)
            if (this.selectedSeatSet.has(seat)) {
              this.hideSeatCard()
              const selectedSeatTicket = this.getSelectedSeatOrderItem(seat, seatElement, seatTickets[0])
              if (
                this.floorPlanTicketFilter !== null &&
                selectedSeatTicket &&
                String(selectedSeatTicket.id) !== String(this.floorPlanTicketFilter)
              ) {
                return
              }
              // an escort ("Pratnja") seat is deselected on its own, outside the regular
              // seat-swap/re-ticket logic - it just frees the escort ticket
              const escortMeta = this.seatSelectionMeta[seat]
              const escortMetaTicket = escortMeta && this.getOrderItemById(escortMeta.ticketId)
              if (
                escortMetaTicket &&
                escortMetaTicket.itemMeta &&
                escortMetaTicket.itemMeta.isEscort
              ) {
                this.removeEscortSeat(seat, svgDoc)

                return
              }
              if (this.currTicket) {
                const oi = this.getOrderItemById(this.currTicket)
                const orderItemIsMembershipOnly = oi.membership
                const seatCurrTicketId = seatElement.getAttribute('ticketId')
                if (
                  (orderItemIsMembershipOnly && seatCurrTicketId !== this.currTicket) ||
                  !this.orderItemMatchesSeatId(oi, seat)
                ) {
                  return
                }
              }
              const seatHasSameColorAsCurrTicket =
                this.isTheaterOrganization || this.event.eventTemplateId
                  ? seatElement.getAttribute('fill') ===
                    this.getOrderItemById(this.currTicket).color
                  : true
              if (seatHasSameColorAsCurrTicket) {
                this.selectedSeats.splice(this.selectedSeats.indexOf(seat), 1)
              }
              this.removeTicketFromCart(
                this.isTheaterOrganization || this.event.eventTemplateId
                  ? this.getOrderItemById(this.currTicket)
                  : selectedSeatTicket,
                seat,
                svgDoc,
              )
              this.resetDeselectedSeatVisual(
                seat,
                svgDoc,
                this.isTheaterOrganization || this.event.eventTemplateId
                  ? this.getOrderItemById(this.currTicket)
                  : selectedSeatTicket,
              )
              // removing an accessible seat also removes the escort seat added for it
              this.removeEscortSeatFor(seat, svgDoc)
              seatHasSameColorAsCurrTicket &&
                this.oneFreeSeatBetweenDeselectedSeatsCheck(seat, svgDoc)
              this.removeExcessBundleGratisSelections(
                this.isTheaterOrganization || this.event.eventTemplateId
                  ? this.getOrderItemById(this.currTicket)
                  : selectedSeatTicket,
                svgDoc,
              )
              this.canAddMoreTickets = this.canAddMoreCheck()
            } else {
              if (
                !e.target.attributes.ticketId ||
                this.seatLimitPerOrder <= this.getNumOfSelectedElements()
              ) {
                return
              }
              if (this.currTicket) {
                const oi = this.getOrderItemById(this.currTicket)
                if (!this.orderItemMatchesSeatId(oi, clickedElement)) return
                const orderItemIsMembershipOnly = oi.membership
                if (
                  orderItemIsMembershipOnly &&
                  this.selectedMembershipTicketCount + 1 > this.membershipTicketLimit
                ) {
                  return
                }
              }
              const seat = clickedElement
              const seatOrderItem =
                this.isTheaterOrganization || this.event.eventTemplateId
                  ? this.getOrderItemById(this.currTicket)
                  : seatTickets[0]
              this.handleTriggerTableTicketDialog(seatTickets[0], seat)
              if (clickedElementType === SvgElementCEType.TABLE) {
                return
              }
              if (seatOrderItem && seatOrderItem.itemMeta && seatOrderItem.itemMeta.max) {
                const currentCount = this.selectedTicketCountById[seatOrderItem.id] || 0
                if (currentCount >= Number(seatOrderItem.itemMeta.max)) {
                  this.snackbarColor = 'error'
                  this.snackbarOpen = true
                  this.snackbarMessage = { workflowCustomer: 'seatMaxLimitReached', params: {} }

                  return
                }
              }

              const coords = this.svgEventToViewportCoords(e)
              if (!coords) {
                return
              }
              this.showSeatCard(seat, seatOrderItem, coords.x, coords.y, 'click')
            }
          }
        }.bind(this),
      )
      this.handleSeatColoring(svgDoc)
      this.handleParterColoring(svgDoc)
      this.renderWheelchairSeatIcons(svgDoc)
      svgDoc.getElementById('svg-pan-zoom-controls').remove()
      this.setZoomButtonsActions(svgDoc)
    },
    handleSeatColoring(svgDoc) {
      const arenaSectionZoomLimit = this.getArenaSectionColorZoomLimit()

      if (this.isTheaterOrganization) {
        this.venue.seats.forEach(seat => {
          const seatElement = svgDoc.getElementById(seat)
          if (!seatElement) {
            return
          }

          this.applyTheaterSeatVisual(seat, seatElement)
        })

        Object.entries(this.ticketLocations || {}).forEach(([ticketId, locations]) => {
          locations.forEach(location => {
            location.seats.forEach(seatNumber => {
              const seatId = `${location.section}_${location.row}_Seat-${seatNumber}`
              const seatElement = svgDoc.getElementById(seatId)
              if (!seatElement) {
                return
              }

              seatElement.setAttribute('ticketId', ticketId)
              this.addWhiteColorOnElementSelect(seatId, svgDoc, ticketId)
            })
          })
        })

        this.rebuildArenaSectionVisualCache(svgDoc, this.getCurrZoom(), arenaSectionZoomLimit)
        this.applyArenaSectionZoomColors(svgDoc, this.getCurrZoom(), arenaSectionZoomLimit)

        return
      }

      const currentTicket = this.getOrderItemById(this.currTicket)
      const selectedSeatSet = this.selectedSeatSet

      this.venue.seats.forEach(seat => {
        if (this.isArenaFanPitTopLevelSectionElement(seat)) {
          return
        }

        const seatElement = svgDoc.getElementById(seat)
        if (!seatElement) {
          return
        }

        seatElement.style.stroke = ''
        const seatTickets = this.getFilteredOrderItemsForSeatId(seat)
        const isSelected = selectedSeatSet.has(seat)
        const selectedSeatTicket = isSelected
          ? this.getSelectedSeatOrderItem(seat, seatElement, seatTickets[0])
          : null
        const seatAvailability = this.venueAvailability[seat]
        if (
          this.floorPlanTicketFilter !== null &&
          (!seatTickets.length ||
            (selectedSeatTicket &&
              String(selectedSeatTicket.id) !== String(this.floorPlanTicketFilter)))
        ) {
          this.applyDisabledElementVisual(seatElement)

          return
        }
        if (
          (seatAvailability &&
            seatAvailability.state === this.seatState.AVAILABLE &&
            seatTickets.length &&
            (this.onlineSale || (!this.onlineSale && seatTickets[0].price > 0))) ||
          isSelected
        ) {
          if (this.event.eventTemplateId) {
            const isDisabledForCurrentTicket = !this.orderItemMatchesSeatId(currentTicket, seat)
            if (isDisabledForCurrentTicket) {
              this.applyDisabledElementVisual(seatElement)
            } else {
              this.applyElementVisual(seatElement, '#979797')
            }
          } else {
            if (seat.includes('Row') && seat.includes('Seat')) {
              this.applyElementVisual(seatElement, seatTickets[0].color)
            } else {
              this.applyElementVisual(seatElement, 'white')
            }
          }
          seatElement.setAttribute(
            'ticketId',
            this.event.eventTemplateId ? this.currTicket : (seatTickets[0] || selectedSeatTicket).id,
          )
          if (isSelected && !this.event.eventTemplateId) {
            seatElement.setAttribute('ticketId', selectedSeatTicket.id)
            this.addWhiteColorOnElementSelect(seat, svgDoc, this.currTicket)
          }
        } else {
          this.applyDisabledElementVisual(seatElement)
        }
      })

      if (this.event.eventTemplateId) {
        Object.entries(this.ticketLocations).forEach(([ticketId, locations]) => {
          locations.forEach(location => {
            location.seats.forEach(seatNumber => {
              const seatId = `${location.section}_${location.row}_Seat-${seatNumber}`
              const seatElement = svgDoc.getElementById(seatId)
              if (!seatElement) {
                return
              }

              seatElement.setAttribute('ticketId', ticketId)
              this.addWhiteColorOnElementSelect(seatId, svgDoc, ticketId)
            })
          })
        })
      }

      this.rebuildArenaSectionVisualCache(svgDoc, this.getCurrZoom(), arenaSectionZoomLimit)
      this.applyArenaSectionZoomColors(svgDoc, this.getCurrZoom(), arenaSectionZoomLimit)
    },
    handleParterColoring(svgDoc) {
      const activeParterOrderItems = this.orderItems
        .filter(oi => oi.itemMeta.parter && this.isWithinSaleTime(oi))
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      const parterIds = new Set(activeParterOrderItems.flatMap(ticket => ticket.sectionSeats))
      parterIds.forEach(id => {
        const parterElement = svgDoc.getElementById(id)
        if (!parterElement) return
        const parterTicket = activeParterOrderItems.find(
          ticket =>
            this.orderItemIsSellable(ticket) &&
            ticket.sectionSeats.includes(id) &&
            (this.floorPlanTicketFilter === null ||
              String(ticket.id) === String(this.floorPlanTicketFilter)),
        )
        if (parterTicket && parterTicket.quantity > 0) {
          this.applyElementVisual(parterElement, parterTicket.color)
        } else {
          this.applyDisabledElementVisual(parterElement)
        }
      })
    },
    hammerInit: function () {
      let eventsHandler
      const venuesWithSpecialDesktopBehavior = [
        Venue.ARENA_ZAGREB,
        'Bundek - Baš Naš',
        'Arena Zagreb 2',
        Venue.ARENA_ZAGREB_PARTER_EXTENDED,
        Venue.ARENA_ZAGREB_PARTER_A_B,
        'Sportska dvorana Gradski vrt',
        'Dvorana Gripe Split - stand up',
        'Arena Zagreb gimnastika žene',
        'Arena Zagreb gimnastika muškarci',
        'Arena Zagreb - stolovi / fan pit (bez gornjih sektora)',
        'Arena Zagreb - stolovi / fan pit',
        Venue.KC_DRAZEN_PETROVIC,
      ]
      const hasSpecialDesktopBehavior = venuesWithSpecialDesktopBehavior.includes(this.venue.name)
      eventsHandler = {
        haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel'],
        init: function (options) {
          let instance = options.instance,
            initialScale = 1,
            pannedX = 0,
            pannedY = 0

          // Init Hammer
          // Listen only for pointer and touch events
          this.hammer = Hammer(options.svgElement, {
            inputClass: Hammer.SUPPORT_POINTER_EVENTS
              ? Hammer.PointerEventInput
              : Hammer.TouchInput,
          })

          // Enable pinch
          this.hammer.get('pinch').set({
            enable: true,
          })

          // Handle double tap
          this.hammer.on('doubletap', function () {
            instance.zoomIn()
          })

          // Handle pan
          this.hammer.on('panstart panmove', function (ev) {
            // On pan start reset panned variables
            if (ev.type === 'panstart') {
              pannedX = 0
              pannedY = 0
            }

            // Pan only the difference
            instance.panBy({
              x: ev.deltaX - pannedX,
              y: ev.deltaY - pannedY,
            })
            pannedX = ev.deltaX
            pannedY = ev.deltaY
          })

          // Handle pinch
          this.hammer.on('pinchstart pinchmove', function (ev) {
            // On pinch start remember initial zoom
            if (ev.type === 'pinchstart') {
              initialScale = instance.getZoom()
              instance.zoomAtPoint(initialScale * ev.scale, {
                x: ev.center.x,
                y: ev.center.y,
              })
            }

            instance.zoomAtPoint(initialScale * ev.scale, {
              x: ev.center.x,
              y: ev.center.y,
            })
          })

          // Prevent moving the page on some devices when panning over SVG
          options.svgElement.addEventListener('touchmove', function (e) {
            e.preventDefault()
          })
        },
        destroy: function () {
          this.hammer.destroy()
        },
      }

      let maxZoom = this.isMobile ? 5 : 3
      if (hasSpecialDesktopBehavior) {
        if (this.isMobile) {
          maxZoom = 30
        } else {
          maxZoom = 9
        }
      }
      // Arena ZG - Stolovi / Fan Pit has dense, detailed seating, so allow a bit more zoom
      if (this.isArenaFanPitVenue()) {
        maxZoom = this.isMobile ? 12 : 6
      }
      this.maxZoom = maxZoom

      // Expose to window namespace for testing purposes
      window.panZoom = svgPanZoom('#svgfile', {
        zoomEnabled: true,
        controlIconsEnabled: true,
        maxZoom,
        minZoom: this.floorPlanMinZoom,
        fit: 2,
        center: 1,
        onZoom: scale => {
          this.hideSeatsAtSpecificZoom(this.getArenaSectionColorZoomLimit(), scale)
          if (!this.isTheaterOrganization) this.checkZoomButtonsState(null, scale)
        },
        customEventsHandler: this.isMobile || hasSpecialDesktopBehavior ? eventsHandler : null,
        beforePan: null,
      })
      if (!this.isTheaterOrganization) this.checkZoomButtonsState()
    },
    canAddParterTicket(ticket) {
      const currentlyAdded = this.elementDetails[ticket.id] || 0

      return currentlyAdded < this.getMaxAllowedNonSeatQuantity(ticket, currentlyAdded)
    },
    showSeatCard(seatId, orderItem, anchorX, anchorY, state) {
      this.seatCardSeatId = seatId
      this.seatCardTicketName = orderItem.name
      this.seatCardPrice = orderItem.price
      this.seatCardCurrency = orderItem.currency || 'EUR'
      this.seatCardDescription = orderItem.description || ''
      this.seatCardType =
        SPECIAL_TABLE_LOCATION_EVENT_IDS.includes(Number(this.event.id)) ||
        TABLE_ROW_LOCATION_ORDER_ITEM_IDS.includes(Number(orderItem.id))
          ? 'table-row'
          : orderItem.itemMeta && orderItem.itemMeta.table
            ? 'table'
            : orderItem.itemMeta && orderItem.itemMeta.parter
              ? 'parter'
              : 'regular'
      this.seatCardTableCapacity = orderItem.itemMeta
        ? (orderItem.itemMeta.min || '') +
          (orderItem.itemMeta.min && orderItem.itemMeta.max ? '-' : '') +
          (orderItem.itemMeta.max || '')
        : ''
      this.seatCardOrderItem = orderItem
      this.seatCardAnchorX = anchorX
      this.seatCardAnchorY = anchorY
      this.seatCardState = state
      this.seatCardShowEscortQuestion =
        state === 'click' && this.shouldShowEscortQuestion(seatId, orderItem)
      this.seatCardVisible = true
    },
    hideSeatCard() {
      this.seatCardVisible = false
      this.seatCardState = 'hover'
      this.seatCardSeatId = ''
      this.seatCardOrderItem = null
      this.seatCardShowEscortQuestion = false
    },
    svgEventToViewportCoords(event) {
      const svgObject = this.getSvgObject()
      if (!svgObject) {
        return null
      }

      const svgRect = svgObject.getBoundingClientRect()
      const evtX = this.isMobile ? event.changedTouches[0].clientX : event.clientX
      const evtY = this.isMobile ? event.changedTouches[0].clientY : event.clientY

      return { x: svgRect.left + evtX, y: svgRect.top + evtY }
    },
    handleSeatCardAdd(payload) {
      const seat = this.seatCardSeatId
      const orderItem = this.seatCardOrderItem
      if (!seat || !orderItem) return

      const svgDoc = this.getSvgDocument()
      const seatElement = svgDoc.getElementById(seat)
      if (
        orderItem.membership &&
        this.selectedMembershipTicketCount + 1 > this.membershipTicketLimit
      ) {
        return
      }

      this.addWhiteColorOnElementSelect(seat, svgDoc, this.currTicket)
      this.selectedSeats.push(seat)
      this.addTicketToCart(
        this.isTheaterOrganization || this.event.eventTemplateId
          ? this.getOrderItemById(this.currTicket)
          : orderItem,
        seat,
      )
      seatElement.setAttribute(
        'ticketId',
        this.isTheaterOrganization || this.event.eventTemplateId ? this.currTicket : orderItem.id,
      )
      this.oneFreeSeatBetweenSelectedSeatsCheck(seat, svgDoc)
      this.canAddMoreTickets = this.canAddMoreCheck()
      if (this.requiredSeats.includes(seat)) {
        this.requiredSeats = this.requiredSeats.filter(requiredSeat => requiredSeat !== seat)
        seatElement.style.fill =
          this.isTheaterOrganization && this.getOrderItemById(this.currTicket)
            ? this.getOrderItemById(this.currTicket).color
            : 'white'
      }
      if (payload && payload.escort && this.seatCardShowEscortQuestion) {
        // seatCardOrderItem already is the effective (currently selected) ticket for theater flows
        this.addEscortSeatToCart(seat, svgDoc, orderItem)
      }
      this.$emit('getSeatPosition', seat)
      this.seatCardState = 'added'
    },
    handleSeatCardCancel() {
      this.hideSeatCard()
    },
  },
}
</script>

<style scoped>
.zkm-seat-availability {
  display: flex;
  justify-content: flex-end;
  padding: 2rem;
  border: solid var(--grey-00, #333);
  border-width: 0 0 2px 0;
}

.attendee-actions-zkm {
  visibility: hidden;
}

.screen-description {
  display: flex;
  width: 50%;
  border: 1px solid #979797;
  justify-content: space-between;
  padding: 10px 26px;
  border-radius: 8px;
}

.description-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #333333;
}

.description-title-zkm {
  font-weight: bold;
}

#description {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}

.ticket-color {
  height: 1rem;
  width: 1rem;
  border-radius: 1000px;
  flex-shrink: 0;
}

.ticket-container {
  border: 1px solid #333333;
  display: flex;
  column-gap: 0.5rem;
  border-radius: 2rem;
  align-items: center;
  padding: 0 0.5rem;
  margin-right: 0.5rem;
  background: white;
}

.ticket-wrapper {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
}

.ticket-wrapper-zkm {
  width: unset;
}

.floor-plan-wrapper {
  border: 1px solid rgba(151, 151, 151, 0.5);
  height: fit-content;
  width: 100%;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
}

.parter-tickets-below-floor-plan {
  margin-top: 1rem;
}

.title-ticket-wrapper {
  padding: 1rem 1.5rem;
  background: #f5f5f5;
  border-radius: 0.3rem 0.3rem 0 0;
  margin-bottom: 0.5rem;
  border-bottom: 1px solid #979797;
}

.title-ticket-wrapper-zkm {
  width: 100%;
  background: none;
  border-radius: 0;
  padding: 2rem 1.5rem;
  border: solid var(--grey-00, #333);
  border-width: 2px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media screen and (max-width: 500px) {
    flex-direction: column;
  }
}

.promo-style {
  margin-top: 2rem;
  margin-bottom: 24px;
  display: flex;
  width: 204px;
}

.center-icon {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  padding-top: 2px;
  text-transform: uppercase;
  margin-left: 6px;
}

.promoCode-wrapper {
  margin-top: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: left;
}

#addPromoCodeText {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 12px !important;
  line-height: 15px;
}

.attendee-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}

.seat-state-wrapper {
  display: flex;
  flex-wrap: wrap;
  background-color: #f5f5f5;
  gap: 1px;
  padding: 1px;
}

.seat-state-wrapper--chips {
  align-items: center;
  gap: 8px;
  padding: 16px 24px;
  border-top: 1px solid rgba(151, 151, 151, 0.5);
  background: transparent;
}

.seat-state-wrapper--chips .seat-state-description {
  flex: 0 1 auto;
  gap: 8px;
  min-width: 0;
  padding: 5px 10px 5px 6px;
  border: 1px solid rgba(151, 151, 151, 0.5);
  border-radius: 32px;
  background: #fff;
  color: #333;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
}

.seat-state-wrapper--chips .seat-state-description img {
  display: block;
  flex-shrink: 0;
}

.seat-state-wrapper--chips .seat-state-description span {
  text-box-edge: cap alphabetic;
  text-box-trim: trim-both;
}

.selected-seat {
  height: 1rem;
  width: 1rem;
  background: white;
  border-radius: 100rem;
  border: 3px solid #333;
}

.bundle-offer-info-banner {
  display: flex;
  align-items: center;
  margin: 0 1rem 0.75rem;
  padding: 0.875rem 1rem;
  border-radius: 12px;
  background: #dfeaf4;
  color: #0058a3;
  font-family: 'Source Sans Pro';
  font-size: 1.125rem;
  line-height: 1.2;
}

.accessible-info-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
  padding: 14px;
  border-radius: 8px;
  background: #f0f6fa;
  color: #0277bd;
  font-family: 'Source Sans Pro';
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
}

.unavailable-seat {
  height: 1rem;
  width: 1rem;
  background: #d9d9d9;
  border-radius: 100rem;
}

.available-seat {
  height: 1rem;
  width: 1rem;
  background: #979797;
  border-radius: 100rem;
}

.unselected-sector-seat {
  height: 1rem;
  width: 1rem;
  background: #d9d9d9;
  border-radius: 100rem;
}

.seat-state-description {
  display: flex;
  padding: 0.5rem 1.25rem;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  flex: 1 0 0;
  background-color: #ffffff;
}

#svg-action-buttons-wrapper {
  display: flex;
  flex-direction: column;
  position: absolute;
  row-gap: 0.5rem;
  top: 20px;
  left: 21px;
}

.floor-plan--standard {
  min-width: 0;
}

.floor-plan--standard .floor-plan-wrapper {
  min-width: 0;
  background: #fff;
}

.floor-plan--standard #svg-action-buttons-wrapper {
  right: 21px;
  left: auto;
}

.floor-plan-zoom-control {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 43px;
  height: 43px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  touch-action: manipulation;
}

.floor-plan-zoom-control:disabled {
  cursor: default;
}

.floor-plan-zoom-control:focus-visible {
  outline: 2px solid #0277bd;
  outline-offset: 2px;
}

.floor-plan-zoom-control__mobile {
  display: none;
}

@media (max-width: 600px), (max-width: 960px) and (max-height: 500px) {
  .floor-plan--standard >>> .module-title {
    font-size: 24px !important;
    line-height: 1.2 !important;
    letter-spacing: -0.72px !important;
  }

  .floor-plan--standard .floor-plan-wrapper {
    border-right: 0;
    border-left: 0;
    border-radius: 0;
  }

  .floor-plan--standard .select-location-title {
    padding: 16px 80px 16px 16px;
  }

  .floor-plan--standard #spinner-svg-wrapper {
    overflow: visible;
  }

  .floor-plan--standard #svgfile {
    display: block;
    height: clamp(320px, 110vw, 560px) !important;
    max-width: 100%;
    padding-top: 8px;
  }

  .floor-plan--standard #svg-action-buttons-wrapper {
    top: -44px;
    right: 12px;
    left: auto;
    row-gap: 4px;
  }

  .floor-plan-zoom-control {
    width: 44px;
    height: 44px;
  }

  .floor-plan-zoom-control__mobile {
    display: block;
  }

  .floor-plan-zoom-control__desktop {
    display: none !important;
  }

  #zoomIn:disabled .floor-plan-zoom-control__mobile {
    opacity: 0.45;
  }
}

.material-icons {
  user-select: none;
  cursor: pointer !important;
  background: white !important;
  height: fit-content;
  border-radius: 1000px !important;
  width: fit-content;
}

#spinner-container {
  height: 600px;
}

.no-tickets {
  display: flex;
  width: fit-content;
  flex-direction: column;
  justify-content: flex-end;
  align-items: start;
  padding-top: 1rem;
  gap: 1rem;
}

#spinner-svg-wrapper {
  height: 200px;
  overflow: hidden;
}

.ticket-price-currency {
  margin-bottom: 0;
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: 'Source Sans Pro';
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.02625rem;
  text-transform: uppercase;
}

.ticket-name {
  margin-bottom: 0;
  color: #333;
  font-family: 'Source Sans Pro';
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}

.ticket-container {
  display: inline-flex;
  align-items: center;
}

.circle {
  width: 10px; /* Adjust size as needed */
  height: 10px;
  border-radius: 50%;
  margin-right: 8px; /* Space between circle and text */
}

.package-info {
  padding: 1.5rem;
  margin-top: 1rem;
  background: #f5f5f5;
  border-top: 1px solid #979797;
  border-radius: 0 0 0.3rem 0.3rem;
}

.package-info h3 {
  font-family: 'Raleway', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #333333;
  margin-bottom: 0.75rem;
  margin-top: 0;
}

.package-info ul {
  list-style-type: disc;
  padding-left: 1.5rem;
  margin: 0;
}

.package-info li {
  font-family: 'Source Sans Pro', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.6;
  color: #333333;
  margin-bottom: 0.25rem;
}

.regular-tickets-title {
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 1.05rem */
  letter-spacing: -0.02625rem;
  padding: 1rem;
}

.regular-ticket-container {
  display: flex;
  padding: 0.5rem 1.25rem;
  align-items: flex-start;
  gap: 0.375rem;
  align-self: stretch;
  border-top: 1px solid #f5f5f5;
  background: #fff;
}

.select-location-title,
.choose-ticket-category-title {
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 1.5rem */
  letter-spacing: -0.0375rem;
  padding-left: 0.5rem;
}

.remaining-tickets-chip {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 0.5rem;
  padding: 0.375rem 0.625rem;
  border-radius: 2rem;
  background: #cee4f2;
  color: #0277bd;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}

.remaining-tickets-chip__count {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-weight: 600;
  letter-spacing: -0.02625rem;
}

.remaining-tickets-chip__count img {
  width: 0.875rem;
  height: 0.875rem;
}

.select-location-title {
  padding: 1rem 1rem 1rem 1.5rem;
}

.choose-ticket-category-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem;
}

.ticket-dropdown-container >>> .v-select__selections {
  padding-top: 0 !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

<style>
.ticket-dropdown-menu .v-list {
  padding: 0 !important;
}

.ticket-dropdown-menu .v-list__tile {
  padding: 0 !important;
  height: auto !important;
}

.ticket-dropdown-menu .v-input__slot {
  padding: 0 8px 0 4px !important;
}

.ticket-bundle-offer-badge {
  display: flex;
  height: 1.125rem;
  padding: 0 0.5rem 0 0.375rem;
  align-items: center;
  gap: 0.25rem;
  border-radius: 2rem;
  background-color: #e5f4ff;
}

.ticket-bundle-offer-badge-text {
  color: #0277bd;
  font-family: 'Raleway', sans-serif;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
}

.ticket-price-container {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
</style>
